<ng-container *ngIf="viewSize=='large'">
  <div class="hpanel">
    <div class="panel-body pad-cus border-radius-top-left-right-6 job-hover-border-v2" [ngClass]="getJobCssClasses()">
      <div class="lg-job-card-container-v2">
        <!-- Left Section - Owner Details -->
        <div class="lg-job-card-user-detail-v2" *ngIf="!showStatus">
          <div style="position: relative; right: 15px;" *ngIf="showCheckBox==true" class="job-custom-checkbox-v2"
            title="Select Jobs to see its activity">
            <label class="checkbox-label font-normal">
              <input id="job_card_select_checkbox" type="checkbox" (click)="selectCheckbox($event.target.checked,JobData)"
                [(ngModel)]="JobData.isSelected" name="list_name" />
              <span class="checkmark" style="top: -5px"></span>
            </label>
          </div>

          <div class="job-owner-section-v2">
            <div class="job-owner-profile-img-v2" style="position: relative;">
              <!-- Role Badges -->
              <span class="label label-success job-ui-align-role-v2" title="Vendor"
                *ngIf="JobData?.user?.userType != 'FREELANCE_RECRUITER'&& JobData?.user?.workExperience!=null && JobData?.user?.workExperience[0]?.clientType=='Vendor'">V</span>
              <span class="label label-success job-ui-align-role-v2" title="Direct Hire"
                *ngIf=" JobData?.user?.userType != 'FREELANCE_RECRUITER'&&  JobData?.user?.workExperience!=null && JobData?.user?.workExperience[0]?.clientType==GigsumoConstant.DIRECT_HIRE">DH</span>
              <span class="label label-success job-ui-align-role-v2" title="Systems Integrator"
                *ngIf="JobData?.user?.userType != 'FREELANCE_RECRUITER'&& JobData?.user?.workExperience!=null && JobData?.user?.workExperience[0]?.clientType=='Systems Integrator'">SI</span>
              <span class="label label-success job-ui-align-role-v2" title="Prime Vendor"
                *ngIf="JobData?.user?.userType != 'FREELANCE_RECRUITER'&& JobData?.user?.workExperience!=null && JobData?.user?.workExperience[0]?.clientType=='Prime Vendor'">PV</span>
              <span class="label label-success job-ui-align-role-v2" title="Recruitment Process Outsourcer"
                *ngIf="JobData?.user?.userType != 'FREELANCE_RECRUITER'&& JobData?.user?.workExperience!=null && JobData?.user?.workExperience[0]?.clientType=='Recruitment Process Outsourcer'">RPO</span>
              <span class="label label-success job-ui-align-role-v2" title="Staffing Agency"
                *ngIf="JobData?.user?.userType != 'FREELANCE_RECRUITER'&& JobData?.user?.workExperience!=null && JobData?.user?.workExperience[0]?.clientType=='Staffing Agency'">SA</span>
              <span class="label label-success job-ui-align-role-v2" title="Direct Client"
                *ngIf="JobData?.user?.userType != 'FREELANCE_RECRUITER'&& JobData?.user?.workExperience!=null && JobData?.user?.workExperience[0]?.clientType=='Direct Client'">DC</span>
              <span class="label label-success job-ui-align-role-v2" title="Client"
                *ngIf="JobData?.user?.userType != 'FREELANCE_RECRUITER'&& JobData?.user?.workExperience!=null && JobData?.user?.workExperience[0]?.clientType=='Client'">C</span>
              <span class="label label-success job-ui-align-role-v2" title="Freelance Recruiter"
                *ngIf="JobData?.user?.userType == 'FREELANCE_RECRUITER'">FR</span>

              <!-- Profile Image/Initials -->
              <div *ngIf="JobData?.user?.photo!=undefined">
                <img class="lg-crd-img" *ngIf="JobData?.user?.photo!=undefined" src={{JobData?.user?.photo}}
                  alt="profile-picture">
              </div>
              <div *ngIf="JobData?.user?.photo == undefined">
                <div class="circles" [style.background-color]="getColor(JobData?.user?.fullname)">
                  <div class="circle-text pad-14" [style.color]="getFullNameTextColor(JobData?.user?.fullname)" style="font-weight: bold;">
                    {{getInitials(JobData?.user?.fullname)}}
                  </div>
                </div>
              </div>
            </div>

            <div class="job-owner-info-v2">
              <div class="job-custom-checkbox-v2" *ngIf="JobData?.currentStatus!='null' && JobData?.currentStatus != 'INITIATED' && JobData?.currentStatus != 'REJECTED' &&
                 JobData?.currentStatus != 'ACCEPTED' && applyingJob" title="Select Job">
                <input class="check-btn-ui check-ui" type="checkbox" value="{{JobData?.user?.userId}}"
                  [(ngModel)]="JobData.isSelected" name="list_name" />
              </div>

              <h6 *ngIf="JobData?.user?.fullname!=null"
                title="{{JobData?.user?.fullname}}"
                class="job-owner-name-v2">
                {{ (JobData?.user?.fullname?.length > 10) ? (JobData?.user?.fullname | slice:0:15) + ".." : JobData.user?.fullname }}
              </h6>

              <div *ngIf="JobDataUser!=null && JobDataUser?.fullname!=null">
                <h6 class="job-owner-name-v2" title="{{JobDataUser?.fullname}}">{{JobDataUser?.fullname}}</h6>
              </div>

              <!-- Job posted on behalf of -->
              <div class="job-owner-org-name-v2" *ngIf="JobData?.jobPostedBehalfOf != 'null'"
                title="{{JobData?.jobPostedBehalfOf}}">
                {{JobData?.jobPostedBehalfOf}}
              </div>

              <div class="job-owner-timestamp-v2" *ngIf="JobData?.updatedOn">
                {{JobData?.updatedOn | timezoneDate:'MM/dd/yyyy'}}
              </div>
              <!-- CEIPAL Badge -->
              <!-- <div *ngIf="JobData?.source == 'CEIPAL'" title="From Ceipal" style="margin-top: 4px;">
                <img src="assets/images/ceipal1.png" alt="ceipal" style="height: 22px; width: auto; border-radius: 50%;" />
              </div> -->
            </div>
          </div>
        </div>
          <ng-container *ngIf="showStatus">
            <div class="col-sm-1">
              <div *ngIf="showCheckBox==true" class="custom-checkbox" title="Select Jobs to see its activity">
                <label class="checkbox-label font-normal">
                  <input id="job_card_select_checkbox_status" type="checkbox" (change)="selectCheckbox($event.target.checked,JobData)"
                    [(ngModel)]="JobData.isSelected" name="list_name" />
                  <span class="checkmark" style="top: 4px"></span>
                </label>
              </div>
            </div>
            <div class="col-sm-1">
              <div *ngIf=" JobData?.user?.photo!=undefined">
                <img *ngIf="JobData?.user?.photo!=undefined" src={{JobData?.user?.photo}} alt="profile-picture">
              </div>
              <div *ngIf=" JobData?.user?.photo == undefined">
                <div class="circles" [style.background-color]="getColor(JobData?.user?.fullname)">
                  <div class="circle-text" [style.color]="getFullNameTextColor(JobData?.user?.fullname)">{{
                    getInitials(JobData?.user?.fullname) }}</div>
                </div>
              </div>
            </div>
            <div class="col-sm-3" *ngIf="showStatus!=undefined">
              <div *ngIf="JobData?.user?.fullname!=null">
                <h6 class="text-wrap-text-invite fw-bold" title="{{JobData?.user?.fullname}}" class="me-5">{{
                  (JobData?.user?.fullname?.length > 10) ?
                  (JobData?.user?.fullname | slice:0:15) + ".." :
                  JobData.user?.fullname }}</h6>
              </div>
              <div *ngIf="JobDataUser!=null">
                <div *ngIf="JobDataUser?.fullname!=null">
                  <h6 class="text-wrap-text-invite fw-bold" title="{{JobDataUser?.fullname}}" class="me-5">{{
                    (JobDataUser?.fullname?.length
                    > 10) ?
                    (JobDataUser?.fullname | slice:0:15) + "..":
                    (JobDataUser?.fullname)}}</h6>
                </div>
              </div>

              <h6 class="text-wrap-text-invite fw-bold" title="{{JobDataUser?.userType}}@{{JobData?.jobPostedBehalfOf}}">
                {{JobDataUser?.userType}} <span>&#64;</span> {{JobData?.jobPostedBehalfOf}}
              </h6>
              <small class="text-muted" *ngIf="JobData?.updatedOn"> {{JobData?.updatedOn | timezoneDate:'MM/dd/yyyy'}}
              </small>
            </div>
            <div class="col-md-7 cardListItm">
              <div class=" flex pull-right actItemList">
                <div class="btn-group" dropdown id="jb_dpDown_2" *ngIf="showStatus">
                  <button data-toggle="dropdown" dropdownToggle id="candidateInviteActionButton"
                    class="btn  status-action-btn fRCard dropdown-toggle"
                    (click)="triggerChange(JobData?.jobReferenceId)" aria-expanded="true"
                    [ngStyle]="getStyle(JobData?.currentStatus)">
                    <ng-container *ngIf="!isExcludedStatus(JobData?.currentStatus)">
                      <ng-icon name="tablerChevronDown" class="arrowclasspad" aria-hidden="true"></ng-icon>
                    </ng-container>
                    <ng-container *ngIf="JobData?.currentStatus === 'INITIATED'"> Invited </ng-container>
                    <ng-container *ngIf="JobData?.currentStatus === 'ACCEPTED'"> Submitted </ng-container>
                    <ng-container *ngIf="JobData?.currentStatus === 'REJECTED'"> Rejected </ng-container>
                  </button>
                  <ng-container *ngIf="!isExcludedStatus(JobData?.currentStatus)">
                    <ul id="dropdown-animated" *dropdownMenu class="dropdown-menu dropdown-menu-right" role="menu"
                      style="right: -118px; left: auto; margin-top: -29px; " aria-labelledby="button-animated">
                      <li role="menuitem" *ngIf="JobData?.currentStatus!='ACCEPTED'" id="candidateInvitesubmitbutton"
                        (click)="updatestatus('ACCEPTED',JobData,RTRtemplate)"> <a><ng-icon name="tablerCircle" class="fs-status-icon t-active" aria-hidden="true"></ng-icon> Submit Resume
                        </a>
                      </li>
                      <li role="menuitem" *ngIf="JobData?.currentStatus!='REJECTED'" id="candidateInviterejectButton"
                        (click)="updatestatus('REJECTED',JobData,RTRtemplate)"> <a><ng-icon name="tablerCircle" class="fs-status-icon t-close" aria-hidden="true"></ng-icon> Reject Invitation
                        </a>
                      </li>
                    </ul>
                  </ng-container>
                </div>

                <button style="color:#fff;" *ngIf="JobData?.status!='DRAFTED' && JobData?.status != 'BLOCKED' && !showStatus" type="button"
                  class="btn  status-action-btn dwidth" [ngStyle]="getStyle(JobData?.currentStatus)">
                  <ng-container *ngIf="JobData?.currentStatus === 'INITIATED'"> Invited </ng-container>
                  <ng-container *ngIf="JobData?.currentStatus === 'INTETEREST_SHOWN'"> Invited </ng-container>
                  <ng-container *ngIf="JobData?.currentStatus != 'INITIATED'">
                    {{JobData?.currentStatus|titlecase}}</ng-container>
                  <ng-container *ngIf="JobData?.status=='ACTIVE' "> Available </ng-container>
                  <ng-container *ngIf="JobData?.status=='INACTIVE' "> UnAvailable </ng-container>
                  <ng-container *ngIf="JobData?.status=='ON HOLD' "> On Hold </ng-container>
                  <ng-container *ngIf="JobData?.status=='FILLED' "> Filled </ng-container>
                  <ng-container *ngIf="JobData?.status=='CLOSED' "> Closed </ng-container>

                </button>



                <div id="job_card_actions_dropdown" (click)="$event.stopPropagation();" class="btn-group "
                  *ngIf="JobData?.jobPostedBy==userId && !applyingJob" dropdown>
                  <a id="button-animated" dropdownToggle>
                    <img src="assets/icon/action.png" class="img-width-dot-icon" />
                  </a>
                  <ul id="dropdown-animated" *dropdownMenu class="dropdown-menu" role="menu"
                    style="right: 0; left: auto;z-index: 2;" aria-labelledby="button-animated">
                    <li role="menuitem">
                      <a id="job_card_view_link" (click)="open(JobData)">
                        View
                      </a>
                    </li>

                  </ul>
                </div>
                <div class="btn-group pull-right" *ngIf="JobData?.jobPostedBy!=userId && !applyingJob" dropdown>
                  <a id="button-animated" dropdownToggle>
                    <img src="assets/icon/action.png" class="img-width-dot-icon" />
                  </a>
                  <ul id="dropdown-animated" *dropdownMenu class="dropdown-menu" role="menu"
                    style="right: 0; left: auto;z-index: 2;" aria-labelledby="button-animated">
                    <li role="menuitem" class="report" *ngIf="reportEnabled"
                      style="display:flex;align-content: space-between;flex-wrap: nowrap;flex-direction: row-reverse;">
                      <app-flag type="JOB" [id]="JobData.jobId" [flagTo]="JobData?.jobPostedBy"
                        [flags]="['Report Job as fake.']">
                      </app-flag>
                    </li>
                    <li role="menuitem">
                      <a id="job_card_view_link2" (click)="open(JobData)">
                        View
                      </a>
                    </li>
                    <li role="menuitem" *ngIf="JobData?.subContracted === true && JobData?.businessId !== businessId && JobData?.organisationId !== businessId && userType !== 'BENCH_RECRUITER'">
                      <a id="job_card_subcontract_link" (click)="openSubContractModal(JobData); $event.stopPropagation()">
                        <ng-icon name="tablerShare" style="margin-right:6px;"></ng-icon>Sub-contract
                      </a>
                    </li>

                  </ul>
                </div>
              </div>
              <div id="job_card_open_details" (click)="open(JobData)">

                <div [ngClass]="{'flex-display': JobData?.status != 'ACTIVE'}" style="margin-bottom: 1rem;">
                  <h6 class="fw-bold" style="flex-grow: 0.4;" *ngIf="!flag">{{JobData?.jobTitle}}</h6>
                  <div class="label-tag" [ngStyle]="getStyle('INACTIVE')"
                    *ngIf="(JobData?.status != 'ACTIVE'||!JobData?.availability)">
                    {{ JobData?.status != 'ACTIVE' ? convertSmallCase(JobData?.status) : 'On Hold' }}</div>
                </div>

                <span *ngIf="!flag">
                  Experience : {{ JobData?.experienceFrom}} to {{JobData?.experienceTo }}
                  Years
                </span>

                <div class="btn-group jobProfileBtngp text-wrapsfilter">

                  <div style="display: flex; column-gap: 0.5rem;" *ngIf="JobData?.primarySkills?.length==1">
                    <div *ngFor="let data of JobData?.primarySkills; let i = index;">
                      <div title="{{data}}" class="ioxlp-1-ele">
                        {{data}}
                      </div>
                    </div>
                  </div>
                  <div style="display: flex; column-gap: 0.5rem;" *ngIf="JobData?.primarySkills?.length==2">
                    <div *ngFor="let data of JobData?.primarySkills; let i = index;">
                      <div title="{{data}}" class="ioxlp-2-ele">
                        {{data}}
                      </div>
                    </div>
                  </div>
                  <div style="display: flex; column-gap: 0.5rem;" *ngIf="JobData?.primarySkills?.length==3">
                    <div *ngFor="let data of JobData?.primarySkills; let i = index;">
                      <div title="{{data}}" class="ioxlp-3-ele">
                        {{data}}
                      </div>
                    </div>
                  </div>
                </div>

                <div style="display: flex; flex-direction: column; width: 100%;">
                  <div class="row clientDetailList" *ngIf="!flag"
                    title=" {{JobData?.clientType}}, {{JobData?.city}}, {{JobData?.state}} ">
                    <div class="mb-5" title="{{JobData.clientName}}" *ngIf="JobData?.showClientName">
                      <ng-icon name="tablerBuilding" class="svg-position"></ng-icon>
                      {{JobData.clientName | truncate:20}}
                    </div>
                    <div class="mb-5" title="{{JobData?.clientType}}" *ngIf="JobData?.showClientType">
                      <ng-icon name="tablerBriefcase" class="svg-position"></ng-icon>
                      {{JobData?.clientType}}
                    </div>
                    <div class="mb-5" title="{{JobData?.city}} , {{JobData?.state}}">
                      <ng-icon name="tablerMapPin" class="svg-position" *ngIf="JobData?.city || JobData?.state"></ng-icon>
                      {{JobData?.city}}
                      <span *ngIf="JobData?.state">,</span> {{JobData?.state}}
                    </div>
                    <div class="mb-5" title="{{JobData?.jobClassification}}">
                      <ng-icon name="tablerBriefcase" title="{{JobData?.jobClassification}}" class="svg-position"></ng-icon>
                      {{JobData?.jobClassification}}
                    </div>
                    <div class="mb-5">
                      <div *ngIf="checkingApplyButton; else commonDetails ">
                        <ng-container *ngIf="JobData?.targetRateFrom && JobData?.targetRateTo; else noRateLargeApply">
                          <span title=" {{JobData?.targetRateFrom}} - {{JobData?.targetRateTo}} ">{{JobData?.country ===
                            'US' ? '$' : ''}} {{JobData?.targetRateFrom}} - {{JobData?.targetRateTo}}</span>
                          <ng-container *ngIf="JobData?.source !== 'CEIPAL'; else ceipalCurLgApply">
                          <span title="{{JobData?.country}}" *ngIf="JobData?.country == 'US'"> USD / </span>
                          <span title="{{JobData?.country}}" *ngIf="JobData?.country == 'IN'"> INR / </span>
                          <span title="{{JobData?.country}}" *ngIf="JobData?.country == 'CA'"> CAD / </span>
                          <span title="{{JobData?.country}}" *ngIf="JobData?.country == 'AU'"> AUD / </span>
                          <span title="{{JobData?.country}}"
                            *ngIf="JobData?.country != 'AU' && JobData?.country != 'US' && JobData?.country != 'CA' && JobData?.country != 'IN'">
                            CUR / </span>
                          </ng-container>
                          <ng-template #ceipalCurLgApply>
                            <span title="{{JobData?.currency}}"> {{ getJobCurrency(JobData) }} / </span>
                          </ng-template>

                          <span title="{{JobData?.payTypeFortheCandidate}}"
                            *ngIf="JobData?.payTypeFortheCandidate == 'Hourly'">Hr</span>
                          <span title="{{JobData?.payTypeFortheCandidate}}"
                            *ngIf="JobData?.payTypeFortheCandidate == 'Daily'">Day</span>
                          <span title="{{JobData?.payTypeFortheCandidate}}"
                            *ngIf="JobData?.payTypeFortheCandidate == 'Weekly'">Week</span>
                          <span title="{{JobData?.payTypeFortheCandidate}}"
                            *ngIf="JobData?.payTypeFortheCandidate == 'Monthly'">Month</span>
                          <span title="{{JobData?.payTypeFortheCandidate}}"
                            *ngIf="JobData?.payTypeFortheCandidate == 'Yearly'">Year</span>
                        </ng-container>
                        <ng-template #noRateLargeApply><span title="Employer estimate: Not available">$ Not
                            available</span></ng-template>
                      </div>

                      <ng-template #commonDetails>
                        <ng-container *ngIf="JobData?.targetRateFrom && JobData?.targetRateTo; else noRateLargeCommon">
                          <span title="{{JobData?.targetRateFrom}} - {{JobData?.targetRateTo}}">{{JobData?.country ===
                            'US' ? "$" : ""}} {{JobData?.targetRateFrom}} - {{JobData?.targetRateTo}}</span>
                          <ng-container *ngIf="JobData?.source !== 'CEIPAL'; else ceipalCurLgCommon">
                          <span title="{{JobData?.country}}" *ngIf="JobData?.country == 'US'"> USD / </span>
                          <span title="{{JobData?.country}}" *ngIf="JobData?.country == 'IN'"> INR / </span>
                          <span title="{{JobData?.country}}" *ngIf="JobData?.country == 'CA'"> CAD / </span>
                          <span title="{{JobData?.country}}" *ngIf="JobData?.country == 'AU'"> AUD / </span>
                          <span title="{{JobData?.country}}"
                            *ngIf="JobData?.country != 'AU' && JobData?.country != 'US' && JobData?.country != 'CA' && JobData?.country != 'IN'">
                            CUR / </span>
                          </ng-container>
                          <ng-template #ceipalCurLgCommon>
                            <span title="{{JobData?.currency}}"> {{ getJobCurrency(JobData) }} / </span>
                          </ng-template>
                          <span title="{{JobData?.payType}}" *ngIf="JobData?.payType == 'Hourly'">Hr</span>
                          <span title="{{JobData?.payType}}" *ngIf="JobData?.payType == 'Daily'">Day</span>
                          <span title="{{JobData?.payType}}" *ngIf="JobData?.payType == 'Weekly'">Week</span>
                          <span title="{{JobData?.payType}}" *ngIf="JobData?.payType == 'Monthly'">Month</span>
                          <span title="{{JobData?.payType}}" *ngIf="JobData?.payType == 'Yearly'">Year</span>
                        </ng-container>
                        <ng-template #noRateLargeCommon><span title="Employer estimate: Not available">$ Not
                            available</span></ng-template>
                      </ng-template>
                    </div>
                    <div *ngIf="JobData?.workMode=='Onsite'" class="mb-5" title="Onsite">
                      <ng-icon name="tablerMapPin" class="svg-position"></ng-icon>
                      Onsite
                    </div>
                    <div *ngIf="JobData?.workMode=='Remote'" class="mb-5" title="Remote">
                      <ng-icon name="tablerMapPin" class="svg-position"></ng-icon>
                      Remote
                    </div>
                    <div *ngIf="JobData?.workMode=='Hybrid'" class="mb-5" title="Hybrid">
                      <ng-icon name="tablerMapPin" class="svg-position"></ng-icon>
                      Hybrid
                    </div>

                  </div>
                </div>
              </div>
              <div class="interactive-elements row actItemLk"
                [ngStyle]="{'cursor': JobData?.jobPostedBy==userId ? 'pointer' : 'context-menu' }"
                [ngClass]="{'disabled': applyingJob==true}">
                <div *ngIf="JobData?.jobPostedBy!=userId && JobData?.viewedByCount > 0" title="Views">
                  <ng-icon name="tablerEye" class="cursor icon-prime-color"></ng-icon> <span class="blue-color">
                    {{ JobData?.viewedByCount | compactCount }}</span> Views
                </div>
                <div *ngIf="JobData?.jobPostedBy!=userId && JobData?.viewedByCount == 0" title="0 Views"
                  style="cursor: context-menu;"> <ng-icon name="tablerEye" class="cursor icon-prime-color"></ng-icon> <span
                    class="blue-color">
                    0 </span> Views
                </div>
                <div id="job_card_views_button" (click)="goTo(JobData, 'views')" *ngIf="JobData?.jobPostedBy==userId && JobData?.viewedByCount > 0"
                  title="Views" style="cursor: pointer;"> <ng-icon name="tablerEye" class="cursor icon-prime-color"></ng-icon> <span
                    class="blue-color">
                    {{ JobData?.viewedByCount | compactCount }}</span> Views
                </div>
                <div id="job_card_no_views_button" *ngIf="JobData?.jobPostedBy==userId && JobData?.viewedByCount == 0"
                  (click)="goTo(JobData, 'noviews')" title="0 Views" style="cursor: pointer;"> <ng-icon name="tablerEye" class="cursor icon-prime-color"></ng-icon> <span class="blue-color">
                    0 </span> Views
                </div>

                <div title="{{JobData?.likesCount}} Likes" *ngIf="JobData?.jobPostedBy==userId">
                  <ng-icon id="job_card_like_button" name="tablerHeart" title="Like" class="pointer icon-prime-color"
                    *ngIf="!JobData?.isLiked" (click)="like(JobData)"></ng-icon>
                  <ng-icon id="job_card_unlike_button" name="tablerHeart" title="Unlike" class="liked pointer bg-heart"
                    *ngIf="JobData?.isLiked" (click)="like(JobData)"></ng-icon>
                  <span id="job_card_likes_count" (click)="goTo(JobData, 'jobs-liked')" *ngIf="JobData?.likesCount>0"
                    style="cursor: pointer;"><span class="blue-color">{{ JobData?.likesCount | compactCount }}</span><span
                      id="job_card_likes_text_button"> Like<span *ngIf="JobData?.likesCount>1">s</span></span></span>
                  <span title="0 Likes" class="no-views" *ngIf="JobData.likesCount == 0"
                    style="cursor: context-menu!important;"><span class="blue-color" title="0 Likes"> 0 </span> Like</span>
                </div>
                <div title="{{JobData?.likesCount}} Likes" *ngIf="JobData?.jobPostedBy!=userId">
                  <ng-icon id="job_card_like_button" name="tablerHeart" title="Like" class="pointer icon-prime-color"
                    *ngIf="!JobData?.isLiked" (click)="like(JobData)"></ng-icon>
                  <ng-icon id="job_card_unlike_button" name="tablerHeart" title="Unlike" class="liked pointer bg-heart"
                    *ngIf="JobData?.isLiked" (click)="like(JobData)"></ng-icon>
                  <span *ngIf="JobData?.likesCount>0" style="cursor: context-menu!important;"><span class="blue-color">{{ JobData?.likesCount | compactCount }}</span><span> Like<span
                        *ngIf="JobData?.likesCount>1">s</span></span></span>
                  <span title="0 Likes" class="no-views" *ngIf="JobData.likesCount == 0"
                    style="cursor: context-menu!important;"><span class="blue-color" title="0 Likes"> 0 </span> Like</span>
                </div>
                <div id="job_card_applied_count_button" title="Applied Count" *ngIf="JobData?.jobPostedBy==userId" (click)="goTo(JobData, 'jobs-applied')">

                  <ng-icon name="tablerUsers"></ng-icon>

                  <span class="blue-color" *ngIf="JobData.appliedCount>0">{{ JobData.appliedCount | compactCount }}</span>
                  <span class="blue-color" *ngIf="JobData.appliedCount==0"> 0</span>
                  <span class="blue-color" *ngIf="JobData.appliedToday>0">
                    ({{JobData.appliedToday}} new)
                  </span>
                  Applicants
                </div>

                <div id="job_card_applicants_button" title="Applied Count" *ngIf="JobData?.jobPostedBy!=userId"
                  (click)="goTo(JobData, 'job-applicants')">

                  <ng-icon name="tablerSend"></ng-icon>
                  <span class="blue-color" *ngIf="JobData.appliedCount>0">{{ JobData.appliedCount | compactCount }}</span>
                  <span class="blue-color" *ngIf="JobData.appliedCount==0"> 0</span>
                  <span class="blue-color" *ngIf="JobData.appliedToday>0">
                    ({{JobData.appliedToday}} new)
                  </span> Applicants
                </div>


                <div id="job_card_invites_count_button" title="Invites Received Count" (click)="goTo(JobData,'candidates-invited')"
                  *ngIf="JobData?.jobPostedBy === userId">
                  <ng-icon name="tablerMail"></ng-icon>

                  <span title="{{JobData?.interestShownCount}} Invites" class="blue-color"
                    *ngIf="JobData?.interestShownCount>0">{{ JobData?.interestShownCount | compactCount }}</span>
                  <span title="0 Invites" class="blue-color" *ngIf="JobData?.interestShownCount==0"> 0 </span>
                  Invites
                </div>
                <div id="jb-apply" title="Apply"
                  [ngClass]="{'disabled': JobData?.status!='ACTIVE' || JobData?.currentStatus=='REJECTED' }"
                  *ngIf="JobData?.jobPostedBy!=userId && (userType == 'BENCH_RECRUITER'  || userType == 'JOB_SEEKER' || userType == 'FREELANCE_RECRUITER' || userType == 'MANAGEMENT_TALENT_ACQUISITION')"
                  (click)="apply(JobData,connectionTemplate,candidateSupplyTemplate)">
                  <ng-icon name="tablerSend"></ng-icon>
                  Apply
                </div>
                <div id="job_card_chat_with_messages" *ngIf="JobData?.chatHistoryCount>0" class="chat-box-icon"
                  (click)="openMessagecheckInteraction(JobData, connectionTemplate)" title="{{JobData.nonSeenMessageCount}} Messages">
                  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="icon-prime-color" aria-hidden="true"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path></svg>
                  <span class="blue-color">{{JobData.nonSeenMessageCount}}</span>
                  Chat
                </div>
                <div id="job_card_chat_no_messages" *ngIf="JobData?.jobPostedBy!=userId && JobData?.chatHistoryCount == 0"
                  (click)="openMessagecheckInteraction(JobData,connectionTemplate)" title="0 Messages" style="cursor: context-menu;"> <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="icon-prime-color"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path></svg>
                  Chat
                </div>
                <div *ngIf="JobData?.jobPostedBy==userId && JobData?.chatHistoryCount == 0" title="0 Messages"
                  style="cursor: context-menu;"> <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="icon-prime-color"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path></svg>
                  Chat
                </div>
                <div class="btn-group" dropdown id="jb_dpDown" *ngIf="!showStatus">
                  <button data-toggle="dropdown" dropdownToggle class="btn btn-primary  btn-xs dropdown-toggle"
                    aria-expanded="true"> Actions <span class="caret"></span></button>
                  <ul id="dropdown-animated" *dropdownMenu class="dropdown-menu dropdown-menu-right" role="menu"
                    style="right: -140px; left: auto; margin-top: -29px; " aria-labelledby="button-animated">
                    <li id="job_card_accept_invitation_button" role="menuitem" *ngIf="JobData?.currentStatus!='ACCEPTED'"
                      (click)="updatestatus('ACCEPTED',JobData,template)"> <a> Accept Invitation </a> </li>
                    <li id="job_card_reject_invitation_button" role="menuitem" *ngIf="JobData?.currentStatus!='REJECTED'"
                      (click)="updatestatus('REJECTED',JobData,template)"> <a> Reject Invitation </a> </li>
                  </ul>
                </div>
              </div>
            </div>
          </ng-container>

          <!-- Middle Section - Job Details -->
          <div class="lg-job-card-detail-v2" *ngIf="!showStatus">
            <div class="job-header-v2">
              <div class="job-title-section-v2">
                <div class="lg-job-title-v2" [class.marketplace-job-title]="pageFrom === 'suggestedJobs' || From === 'SUGGESTED_JOBS'" *ngIf="!flag" (click)="open(JobData)"
                  title="{{JobData?.jobTitle}}">
                    {{ JobData?.jobTitle }}
                </div>

                <div class="job-experience-v2" *ngIf="!flag">
                  Experience: {{JobData?.experienceFrom}} to {{JobData?.experienceTo}} Years
                </div>
              </div>

              <div class="urgent-hire-container" *ngIf="getActiveUrgencyDays(JobData) as urgencyDays">
                <span class="urgent-hire-badge"><ng-icon name="tablerFlame" class="urgent-hire-icon"></ng-icon> Urgent Hire</span>
                <span class="urgent-hire-countdown">Urgency ends in {{urgencyDays}} day{{urgencyDays === 1 ? '' : 's'}}</span>
              </div>

              <!-- Skills Section - Separate row for vertical expansion -->
              <div class="job-skills-container-v2">
                <div class="job-skills-v2">
                  <div *ngFor="let data of (skillsExpanded ? JobData?.primarySkills : JobData?.primarySkills?.slice(0, 3))">
                    <div title="{{data}}" class="job-skill-badge-v2"><span class="job-skill-badge-text-v2">{{data}}</span></div>
                  </div>

                  <!-- More button -->
                  <div class="job-skill-more-btn-v2"
                       *ngIf="JobData?.primarySkills?.length > 3"
                       (click)="toggleSkills(); $event.stopPropagation()">
                    <span *ngIf="!skillsExpanded">+{{JobData?.primarySkills?.length - 3}} more</span>
                    <span *ngIf="skillsExpanded">Show less</span>
                  </div>
                </div>
              </div>
            </div>

            <!-- Job Details Grid -->
            <div class="job-details-grid-v2" id="job_card_details_button" (click)="open(JobData)" *ngIf="!flag">
              <div class="job-detail-item-v2" title="{{JobData.clientName}}" *ngIf="JobData?.showClientName">
                <ng-icon name="tablerBuilding" class="svg-position"></ng-icon>
                {{JobData.clientName | truncate:20}}
              </div>

              <div class="job-detail-item-v2" title="{{JobData?.clientType}}" *ngIf="JobData?.showClientType">
                <ng-icon name="tablerBriefcase" class="svg-position"></ng-icon>
                {{JobData?.clientType}}
              </div>

              <div class="job-detail-item-v2" title="{{JobData?.city}}, {{JobData?.state}}">
                <ng-icon name="tablerMapPin" *ngIf="JobData?.city || JobData?.state" class="svg-position"></ng-icon>
                {{JobData?.city}}<span *ngIf="JobData?.state">,</span> {{JobData?.state}}
              </div>

              <div class="job-detail-item-v2" title="{{JobData?.jobClassification}}">
                <ng-icon name="tablerBriefcase" class="svg-position" title="{{JobData?.jobClassification}}"></ng-icon>
                {{JobData?.jobClassification}}
              </div>

              <div class="job-detail-item-v2" title="{{JobData?.payType}}">
                <ng-container *ngIf="JobData?.targetRateFrom && JobData?.targetRateTo; else noRateLargeV2">
                  {{JobData?.country == 'US' ? '$' : ''}} {{JobData?.targetRateFrom}} - {{JobData?.targetRateTo}}
                  <ng-container *ngIf="JobData?.source !== 'CEIPAL'; else ceipalCurLgV2">
                  <span *ngIf="JobData?.country == 'US'"> USD / </span>
                  <span *ngIf="JobData?.country == 'IN'"> INR / </span>
                  <span *ngIf="JobData?.country == 'CA'"> CAD / </span>
                  <span *ngIf="JobData?.country == 'AU'"> AUD / </span>
                  <span *ngIf="JobData?.country != 'AU' && JobData?.country != 'US' && JobData?.country != 'CA' && JobData?.country != 'IN'">
                    CUR /
                  </span>
                  </ng-container>
                  <ng-template #ceipalCurLgV2>
                    <span title="{{JobData?.currency}}"> {{ getJobCurrency(JobData) }} / </span>
                  </ng-template>
                  {{checkingApplyButton ? (JobData?.payTypeFortheCandidate !=null ? JobData?.payTypeFortheCandidate : JobData?.payType) : JobData?.payType}}
                </ng-container>
                <ng-template #noRateLargeV2><span title="Employer estimate: Not available">$ Not available</span></ng-template>
              </div>

              <div *ngIf="JobData?.workMode=='Onsite'" class="job-detail-item-v2" title="Onsite">
                <ng-icon name="tablerMapPin" class="svg-position"></ng-icon>
                Onsite
              </div>
              <div *ngIf="JobData?.workMode=='Remote'" class="job-detail-item-v2" title="Remote">
                <ng-icon name="tablerMapPin" class="svg-position"></ng-icon>
                Remote
              </div>
              <div *ngIf="JobData?.workMode=='Hybrid'" class="job-detail-item-v2" title="Hybrid">
                <ng-icon name="tablerMapPin" class="svg-position"></ng-icon>
                Hybrid
              </div>
            </div>
            <!-- Interactive Elements - Bottom Section -->
            <div class="job-interactive-elements-v2"
              [ngClass]="{'disabled': applyingJob===true ||  (JobData?.jobPostedBy === userId && ['BLOCKED','FILLED'].includes(JobData?.status)) ||
              (JobData?.jobPostedBy !== userId && ['FILLED', 'DRAFTED', 'ON HOLD','BLOCKED'].includes(JobData?.status))}" >
              <div *ngIf="JobData?.jobPostedBy!=userId && JobData?.viewedByCount > 0" [title]="JobData?.viewedByCount + (JobData?.viewedByCount === 1 ? ' View' : ' Views')"
                style="cursor: context-menu;">
                <ng-icon name="tablerEye" class="cursor icon-prime-color"></ng-icon> <span class="blue-color">
                  {{ JobData?.viewedByCount | compactCount }}</span> Views
              </div>
              <div *ngIf="JobData?.jobPostedBy!=userId && JobData?.viewedByCount == 0" title="0 Views"
                style="cursor: context-menu;"> <ng-icon name="tablerEye" class="cursor icon-prime-color"></ng-icon> <span
                  class="blue-color">
                  0</span> Views
              </div>
              <div (click)="goTo(JobData, 'views')" *ngIf="JobData?.jobPostedBy==userId && JobData?.viewedByCount > 0"
                [title]="JobData?.viewedByCount + (JobData?.viewedByCount === 1 ? ' View' : ' Views')"
                 style="cursor: pointer;"> <ng-icon name="tablerEye" class="cursor icon-prime-color"></ng-icon> <span
                  class="blue-color">
                  {{ JobData?.viewedByCount | compactCount }}</span> Views
              </div>
              <div *ngIf="JobData?.jobPostedBy==userId && JobData?.viewedByCount == 0" title="0 Views"
                style="cursor: pointer;"> <ng-icon name="tablerEye" class="cursor icon-prime-color"></ng-icon><span class="blue-color">
                  0</span> Views
              </div>

              <div title="{{JobData.likesCount}} Likes" *ngIf="JobData.jobPostedBy==userId"
                style="cursor: context-menu!important;">
                <ng-icon name="tablerHeart" title="Like" class="pointer icon-prime-color" *ngIf="!JobData?.isLiked"
                  (click)="like(JobData)"></ng-icon>
                <ng-icon name="tablerHeart" title="Unlike" class="liked pointer bg-heart" *ngIf="JobData?.isLiked"
                  (click)="like(JobData)"></ng-icon>
                <span (click)="goTo(JobData, 'jobs-liked')" *ngIf="JobData.likesCount>0" style="cursor: pointer;"><span
                    class="blue-color">{{ JobData.likesCount | compactCount }}</span><span> Like<span *ngIf="JobData.likesCount>1">s</span></span></span>
                <span title="0 Likes" class="no-views" *ngIf="JobData.likesCount == 0"
                  style="cursor: context-menu!important;"><span class="blue-color" title="0 Likes"> 0 </span> Like</span>
              </div>

              <div title="{{JobData.likesCount}} Likes" *ngIf="JobData.jobPostedBy!=userId"
                style="cursor: context-menu!important;">
                <ng-icon name="tablerHeart" title="Like" class="pointer icon-prime-color" *ngIf="!JobData?.isLiked"
                  (click)="like(JobData)"></ng-icon>
                <ng-icon name="tablerHeart" title="Unlike" class="liked pointer bg-heart" *ngIf="JobData?.isLiked"
                  (click)="like(JobData)"></ng-icon>
                <span *ngIf="JobData.likesCount>0"><span class="blue-color">{{ JobData.likesCount | compactCount }}</span><span> Like<span
                      *ngIf="JobData.likesCount>1">s</span></span></span>
                <span title="0 Likes" class="no-views" *ngIf="JobData.likesCount == 0"
                  style="cursor: context-menu!important;"><span class="blue-color" title="0 Likes"> 0 </span> Like</span>
              </div>
              <div [title]="(JobData.appliedCount | compactCount) + ' Applied'"
               *ngIf="JobData?.jobPostedBy==userId" (click)="goTo(JobData, 'job-applicants')">
                <ng-icon name="tablerUsers"></ng-icon>

                <span class="blue-color" *ngIf="JobData.appliedCount>0">{{ JobData.appliedCount | compactCount }}</span>
                <span class="blue-color" *ngIf="JobData.appliedCount==0"> 0</span>
                <span class="blue-color" *ngIf="JobData.appliedToday>0">
                  ({{JobData.appliedToday}} new)
                </span>
                Applicants
              </div>

              <div id="job_card_small_applied_count_button" class="cursor-context-menu"
               [title]="(JobData.appliedCount | compactCount)  + ' Applied'" *ngIf="JobData?.jobPostedBy!=userId"
                (click)="goTo(JobData, 'job-applicants')">
                <ng-icon name="tablerUsers"></ng-icon>

                <span class="blue-color" *ngIf="JobData.appliedCount>0">{{ JobData.appliedCount | compactCount }}</span>
                <span class="blue-color" *ngIf="JobData.appliedCount==0"> 0</span>
                <span class="blue-color" *ngIf="JobData.appliedToday>0">
                  ({{JobData.appliedToday}} new)
                </span>
                Applicants
              </div>

              <div id="job_card_small_invites_count_button" title="Invites Received Count" (click)="goTo(JobData,'candidates-invited')"
                *ngIf="JobData?.jobPostedBy === userId">
                <ng-icon name="tablerMail"></ng-icon>

                <span title="{{JobData?.interestShownCount}} Invites" class="blue-color"
                  *ngIf="JobData?.interestShownCount>0">{{ JobData?.interestShownCount | compactCount }}</span>
                <span title="0 Invites" class="blue-color" *ngIf="JobData?.interestShownCount==0"> 0 </span>
                Invites
              </div>

              <div id="job_card_small_apply_button" title="Apply"
                [ngClass]="{'disabled': JobData?.status!='ACTIVE'|| JobData?.currentStatus=='REJECTED'}"
                *ngIf="JobData?.jobPostedBy!=userId && (userType === 'BENCH_RECRUITER'  || userType === 'JOB_SEEKER' || userType === 'FREELANCE_RECRUITER' || userType === 'MANAGEMENT_TALENT_ACQUISITION')"
                (click)="apply(JobData,connectionTemplate,candidateSupplyTemplate)">

                <ng-icon name="tablerSend"></ng-icon>
                Apply
              </div>
              <div id="job_card_small_chat_with_messages" *ngIf="JobData?.chatHistoryCount>0" class="chat-box-icon"
                (click)="openMessagecheckInteraction(JobData, connectionTemplate)"  title="{{JobData.nonSeenMessageCount > 0 ? JobData.nonSeenMessageCount + ' Messages' : 'No Messages'}}">
                <span class="chat-icon-wrapper">
                  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="icon-prime-color"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path></svg>
                  <span class="noti-badge noti-chat-ic" *ngIf="JobData.nonSeenMessageCount> 0" >{{JobData.nonSeenMessageCount}}</span>
                </span>
                Chat
              </div>
              <div id="job_card_small_chat_no_messages" *ngIf="JobData?.jobPostedBy!=userId && JobData?.chatHistoryCount == 0"
                (click)="openMessagecheckInteraction(JobData,connectionTemplate)" title="No Messages" style="cursor: context-menu;"> 
                <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="icon-prime-color"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path></svg>
                Chat
              </div>
              <div *ngIf="JobData?.jobPostedBy==userId && JobData?.chatHistoryCount == 0" title="No Messages"
                style="cursor: context-menu;"> 
                <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="icon-prime-color"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path></svg>
                Chat
              </div>
              <div class="btn-group" dropdown id="jb_dpDown" *ngIf="!showStatus && showStatus!=undefined">
                <button data-toggle="dropdown" dropdownToggle class="btn btn-primary  btn-xs dropdown-toggle"
                  aria-expanded="true"> Actions <span class="caret"></span></button>
                <ul id="dropdown-animated" *dropdownMenu class="dropdown-menu dropdown-menu-right" role="menu"
                  style="right: -140px; left: auto; margin-top: -29px; " aria-labelledby="button-animated">

                  <li role="menuitem" *ngIf="JobData?.currentStatus!='ACCEPTED'"
                    (click)="updatestatus('ACCEPTED',JobData,template)"> <a> Accept Invitation </a> </li>
                  <li role="menuitem" *ngIf="JobData?.currentStatus!='REJECTED'"
                    (click)="updatestatus('REJECTED',JobData,template)"> <a> Reject Invitation </a> </li>
                </ul>
              </div>
            </div>
          </div>
          <!-- End of Middle Section -->

          <!-- Right Section - Status (Absolute Positioned) -->
          <div class="lg-job-card-status-v2">
            <div class="job-status-section-v2">
              <button *ngIf="!showStatus" class="job-status-button-v2" [ngClass]="{'lg-active-label':(JobData?.currentStatus === 'INITIATED'),
                                                      'lg-interest-shown-label':(JobData?.currentStatus === 'INTETEREST_SHOWN'),
                                                      'lg-active-lable-new':(JobData?.status == 'ACTIVE'),
                                                      'lg-active-non-owner-label':(JobData?.currentStatus && JobData?.currentStatus !== 'INITIATED'),
                                                      'lg-inactive-label':(JobData?.status=='INACTIVE'),
                                                      'lg-filled-label':(JobData?.status=='FILLED'),
                                                      'lg-onhold-label':(JobData?.status=='ON HOLD'),
                                                      'lg-draft-label':(JobData?.status=='DRAFTED'),
                                                      'lg-closed-label':(JobData?.status=='CLOSED'),
                                                      'lg-blocked-label':(JobData?.status=='BLOCKED')}">
                <ng-container *ngIf="JobData?.currentStatus === 'INITIATED'"> Invited </ng-container>
                <ng-container *ngIf="JobData?.currentStatus === 'INTETEREST_SHOWN'"> Invited </ng-container>
                <ng-container *ngIf="JobData?.currentStatus != 'INITIATED'">
                  {{JobData?.currentStatus|titlecase}}</ng-container>
                <ng-container *ngIf="JobData?.status=='INACTIVE' "> Inactive </ng-container>
                <ng-container *ngIf="JobData?.status=='ACTIVE' "> Active </ng-container>
                <ng-container *ngIf="JobData?.status=='DRAFTED' "> Draft </ng-container>
                <ng-container *ngIf="JobData?.status=='ON HOLD' "> On Hold </ng-container>
                <ng-container *ngIf="JobData?.status=='FILLED' "> Filled </ng-container>
                <ng-container *ngIf="JobData?.status=='CLOSED' "> Closed </ng-container>
                <ng-container *ngIf="JobData?.status=='BLOCKED' "> Blocked </ng-container>
              </button>

              <div (click)="$event.stopPropagation();" class="job-action-menu-v2"
                *ngIf="JobData?.jobPostedBy==userId && !applyingJob" dropdown>
                <a id="button-animated" dropdownToggle>
                  <img src="assets/icon/action.png" class="img-width-dot-icon" />
                </a>
                <ul id="dropdown-animated" *dropdownMenu class="dropdown-menu" role="menu"
                  style="right: 0; left: auto;z-index: 2;" aria-labelledby="button-animated">
                  <li role="menuitem">
                    <a (click)="open(JobData)">
                      View
                    </a>
                  </li>
                </ul>
              </div>

              <div class="job-action-menu-v2" *ngIf="JobData?.jobPostedBy!=userId && !applyingJob" dropdown>
                <a id="button-animated" dropdownToggle>
                  <img src="assets/icon/action.png" class="img-width-dot-icon" />
                </a>
                <ul id="dropdown-animated" *dropdownMenu class="dropdown-menu" role="menu"
                  style="right: 0; left: auto;z-index: 2;" aria-labelledby="button-animated">
                  <li role="menuitem" class="report" *ngIf="reportEnabled"
                    style="display:flex;align-content: space-between;flex-wrap: nowrap;flex-direction: row-reverse;">
                    <app-flag type="JOB" [id]="JobData.jobId" [flagTo]="JobData?.jobPostedBy"
                      [flags]="['Report Job as fake.']">
                    </app-flag>
                  </li>
                  <li role="menuitem">
                    <a (click)="open(JobData)">
                      View
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
      </div>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="viewSize == 'medium'">
  <div class="hpanel">
    <div id="jobBody" class="panel-body border-radius-top-left-right-6" [ngClass]="{
          'disabled': !JobData?.availability || JobData?.status != 'ACTIVE' || (candidateData && (!candidateData.availability || candidateData.status !== 'ACTIVE')),
          'pad-0': viewSize == 'medium',
          'highLightList': JobData?.isSelected,
          'featured-background': JobData?.isFeatured==true
         }">
      <div class="profile-card pad-10">
        <div class="md-top-section">
          <div class="md-user-img">
            <!-- <div *ngIf=" !JobDataUser&&JobData?.user?.photo!=undefined">
              <img *ngIf="JobData?.user?.photo!=undefined" src={{JobData?.user?.photo}} alt="profile-picture">
            </div>
            <div *ngIf=" !JobDataUser&&JobData?.user?.photo == undefined">
              <div class="circles" [style.background-color]="getColor(JobData?.user?.fullname)">
                <div class="circle-text" [style.color]="getFullNameTextColor(JobData?.user?.fullname)">{{
                  getInitials(JobData?.user?.fullname) }}</div>
              </div>
            </div>
            <div *ngIf=" JobDataUser&&JobDataUser?.photo!=undefined">
              <img *ngIf="JobDataUser?.photo!=undefined" src={{JobDataUser?.photo}} alt="profile-picture">
            </div>
            <div *ngIf=" JobDataUser&&JobDataUser?.photo == undefined">
              <div class="circles" [style.background-color]="getColor(JobDataUser?.fullname)">
                <div class="circle-text" [style.color]="getFullNameTextColor(JobDataUser?.fullname)">{{
                  getInitials(JobDataUser?.fullname) }}</div>
              </div>
            </div> -->

            <div *ngIf=" JobData?.user?.photo!=undefined">
              <img class="lg-crd-img" *ngIf="JobData?.user?.photo!=undefined" src={{JobData?.user?.photo}}
                alt="profile-picture">
            </div>
            <div *ngIf=" JobData?.user?.photo == undefined">
              <div class="circle-1" [style.background-color]="getColor(JobData?.user?.fullname)">
                <div class="circular-text" [style.color]="getFullNameTextColor(JobData?.user?.fullname)">{{
                  getInitials(JobData?.user?.fullname) }}</div>
              </div>
            </div>
          </div>
          <div class="md-user-info">
            <div class="md-user-info-line-1">
              <div class="md-user-name" title="{{JobData.user?.fullname}}">
                {{JobDataUser?.fullname}}</div>
            </div>
            <div class="md-user-info-line-2">
              <div *ngIf="userTypeMap[JobData?.user?.userType]" class="md-user-type" title="{{JobData.user?.userType}}">
                {{ userTypeMap[JobData?.user?.userType] }}
              </div>
              <span *ngIf="JobData?.jobPostedBehalfOf!='null'&&JobData?.jobPostedBehalfOf!=undefined">&#64;</span>
              <div *ngIf="JobData?.jobPostedBehalfOf!='null'&&JobData?.jobPostedBehalfOf!=undefined"
                class="md-current-org f-half" title="{{JobData.jobPostedBehalfOf}}">{{JobData.jobPostedBehalfOf}}
              </div>

            </div>
            <div class="md-user-info-line-3">
              <ng-icon name="tablerClock"></ng-icon>
              <div class="md-time-stamp"> {{ JobData?.activityDate | timezoneDate }}</div>
              <!-- CEIPAL Badge -->
              <!-- <div *ngIf="JobData?.source == 'CEIPAL'" title="From Ceipal" style="margin-left: 8px;">
                <img src="assets/images/ceipal1.png" alt="ceipal" style="height: 20px; width: auto; border-radius: 50%;" />
              </div> -->
            </div>
          </div>

          <div class="md-action-buttons">
            <div class="btn-group" dropdown id="jb_dpDown_4" *ngIf="showStatus"
              [ngClass]="{disabled : !candidateData?.availability || candidateData?.status != 'ACTIVE' }">
              <button data-toggle="dropdown" style="position: relative; right: 22px;" dropdownToggle
                id="candidateInviteActionButton" class="btn btn-xs  dropdown-toggle"
                (click)="triggerChange(JobData?.jobReferenceId)" style="color:#fff;" aria-expanded="true"
                [ngStyle]="getStyle(JobData?.currentStatus)"> <span> </span>
                <ng-container> {{ getFilterValue(JobData?.currentStatus , 'JOB_INVITE') | titlecase }} </ng-container>
                <ng-container *ngIf="!isExcludedStatus(JobData?.currentStatus , 'JOB_INVITE')">
                  <ng-icon name="tablerChevronDown" aria-hidden="true"></ng-icon>
                </ng-container>
              </button>
              <ng-container *ngIf="!isExcludedStatus(JobData?.currentStatus , 'JOB_INVITE')">
                <ul id="dropdown-animated" *dropdownMenu class="dropdown-menu dropdown-menu-right" role="menu"
                  aria-labelledby="button-animated">

                  <li role="menuitem" *ngFor="let statusData of filterApplicant(JobData?.currentStatus , 'JOB_INVITE')"
                    id="candidateInvitesubmitbutton" (click)="updatestatus(statusData?.itemId ,JobData,RTRtemplate)"
                    id="{{statusData?.item}}"> <a><ng-icon name="tablerCircle" class="fs-status-icon t-active" aria-hidden="true"></ng-icon>
                      {{statusData?.item | titlecase}}
                    </a>
                  </li>

                </ul>
              </ng-container>
            </div>

            <div class="btn-group" [ngClass]="{disabled : !candidateData?.availability || candidateData?.status != 'ACTIVE' }" dropdown
              *ngIf="JobData?.status != 'DRAFTED' && !showStatus &&!jobstatus">
              <button id="jb_dpDown_1" style="color:#fff; margin-left: -42px;" class="btn btn-xs md-listing-btn" dropdownToggle
                aria-expanded="true" [ngStyle]="getStyle(JobData?.currentStatus)">
                <ng-container
                  *ngIf="JobData?.currentStatus === 'INITIATED' || JobData?.currentStatus === 'INTETEREST_SHOWN'">
                  Invited </ng-container>
                <ng-container *ngIf="JobData?.currentStatus === 'ACTIVE'"> Active </ng-container>
                <ng-container
                  *ngIf="JobData?.currentStatus !== 'INITIATED' && JobData?.currentStatus !== 'INTETEREST_SHOWN'">
                  {{ getFilterValue(JobData?.currentStatus) | titlecase }}
                </ng-container>
                <ng-icon name="tablerChevronDown" *ngIf="!isExcludedStatus(JobData?.currentStatus)" 
                  aria-hidden="true"></ng-icon>
              </button>
              <ng-container *ngIf="!isExcludedStatus(JobData?.currentStatus)">
                <ul id="dropdown-animated" *dropdownMenu class="dropdown-menu" role="menu"
                  aria-labelledby="jb_dpDown">
                  <li role="menuitem" *ngFor="let statusData of filterApplicant(JobData?.currentStatus)"
                    (click)="updatestatuswithdraw(statusData , JobData)" id="{{statusData?.item}}">
                    <a id="{{statusData?.item}}"><ng-icon name="tablerCircle" class="fs-status-icon" aria-hidden="true"></ng-icon>&nbsp;
                      {{statusData?.item}}
                    </a>
                  </li>
                </ul>
              </ng-container>
            </div>
            <button *ngIf="jobstatus" type="button" class="btn btn-xs btn-primary">
              Active
            </button>

            <button *ngIf="['OFFER-ACCEPTED','PRE-ONBOARDED','ONBOARDED'].includes(JobData.currentStatus)"   
              class="btn btn-primary" (click)="openDocuments()">Documents
            </button>

            <div (click)="$event.stopPropagation();" class="btn-group "
              *ngIf="JobData?.jobPostedBy==userId && !applyingJob" dropdown>

              <ng-icon name="tablerDotsVertical" dropdownToggle class="svg-position cursor-pointer"></ng-icon>

              <ul id="dropdown-animated" *dropdownMenu class="dropdown-menu" role="menu"
                style="right: 0; left: auto;z-index: 2;" aria-labelledby="button-animated">
                <li role="menuitem">
                  <a (click)="open(JobData)">
                    View
                  </a>
                </li>
              </ul>
            </div>
            <div class="btn-group pull-right" *ngIf="JobData?.jobPostedBy!=userId && !applyingJob" dropdown>

              <ng-icon name="tablerDotsVertical" dropdownToggle class="svg-position cursor-pointer"></ng-icon>
              <ul id="dropdown-animated" *dropdownMenu class="dropdown-menu" role="menu"
                style="right: 0; left: auto;z-index: 2;" aria-labelledby="button-animated">
                <li role="menuitem" class="report" *ngIf="reportEnabled"
                  style="display:flex;align-content: space-between;flex-wrap: nowrap;flex-direction: row-reverse;">
                  <app-flag type="JOB" [id]="JobData.jobId" [flagTo]="JobData?.jobPostedBy"
                    [flags]="['Report Job as fake.']">
                  </app-flag>
                </li>
                <li role="menuitem">
                  <a (click)="view(JobData)">
                    View
                  </a>
                </li>

              </ul>
            </div>
          </div>
        </div>
        <div class="md-bottom-section">
          <div class="col-sm-2 md-btn-container">
            <div *ngIf="showCheckBox==true||showCheckBox=='true'" class="custom-checkbox"
              title="Select Jobs to see its activity">
              <label class="checkbox-label font-normal">

                <input type="checkbox" (click)="selectCheckbox($event.target.checked,JobData)"
                  [(ngModel)]="JobData.isSelected"
                  [disabled]="(selectedjobCount>=allowedJobCandidateCounts && JobData.isSelected==false && isDowngraded) "
                  name="list_name" />
                <span class="checkmark" style="top: -5px"></span>
              </label>
            </div>
          </div>
          <div class="col-sm-10 md-job-route-content mr-23" [ngClass]="{'click-blocked': isRoutingDisabled}"
            (click)="open(JobData)">
            <div class="title-status-container">
              <ng-icon name="tablerBriefcase" class="svg-position"></ng-icon>
              <div class="md-job-title" title="{{JobData.jobTitle}}">{{JobData.jobTitle}}</div>

              <div class="label-tag" [ngStyle]="getStyle('INACTIVE')"
                *ngIf="(JobData?.status != 'ACTIVE'||!JobData?.availability)">
                {{ JobData?.status != 'ACTIVE' ? convertSmallCase(JobData?.status) : 'On Hold' }}</div>
            </div>

            <div class="urgent-hire-container" *ngIf="getActiveUrgencyDays(JobData) as urgencyDays">
              <span class="urgent-hire-badge"><ng-icon name="tablerFlame" class="urgent-hire-icon"></ng-icon> Urgent Hire</span>
              <span class="urgent-hire-countdown">Urgency ends in {{urgencyDays}} day{{urgencyDays === 1 ? '' : 's'}}</span>
            </div>

            <span *ngIf="!flag" class="md-experience">
              Experience : {{ JobData?.experienceFrom}} to {{JobData?.experienceTo }}
              Years
            </span>

            <div class="btn-group jobProfileBtngp text-wrapsfilter">
              <div class="skill-contianer" *ngIf="JobData?.primarySkills?.length==1">
                <div *ngFor="let data of JobData?.primarySkills; let i = index;">
                  <div title="{{data}}" class="ioxlp-1-ele">
                    {{data}}
                  </div>
                </div>
              </div>
              <div class="skill-contianer" *ngIf="JobData?.primarySkills?.length==2">
                <div *ngFor="let data of JobData?.primarySkills; let i = index;">
                  <div title="{{data}}" class="ioxlp-2-ele">
                    {{data}}
                  </div>
                </div>
              </div>
              <div class="skill-contianer" *ngIf="JobData?.primarySkills?.length==3">
                <div *ngFor="let data of JobData?.primarySkills; let i = index;">
                  <div title="{{data}}" class="ioxlp-3-ele">
                    {{data}}
                  </div>
                </div>
              </div>
            </div>



            <div class="md-details">
              <div *ngIf="JobData.showClientName" title="{{JobData.clientName}}" class="md-client-name">
                <ng-icon name="tablerBuilding" class="mr-rt-5"></ng-icon>
                {{JobData.clientName | truncate:20}}
              </div>
              <div class="mb-5" title="{{JobData?.clientType}}" *ngIf="JobData?.showClientType">
                <ng-icon name="tablerBriefcase" class="svg-position"></ng-icon>
                {{JobData?.clientType}}
              </div>
              <div class="md-client-location" title="{{JobData.city}}, {{JobData.state}}">
                <ng-icon name="tablerMapPin" class="svg-position"></ng-icon>
                {{JobData.city}}<span *ngIf="JobData.state">,</span> {{JobData.state}}
              </div>
              <div title="{{JobData.jobClassification}}" class="md-client-type">
                <ng-icon name="tablerBriefcase" class="svg-position"></ng-icon>
                {{JobData.jobClassification}}
              </div>
              <div *ngIf="JobData?.workMode=='Onsite'" class="md-job-relocation" title="Onsite">
                <ng-icon name="tablerMapPin" class="svg-position"></ng-icon>
                Onsite
              </div>
              <div *ngIf="JobData?.workMode=='Remote'" class="md-job-relocation" title="Remote">
                <ng-icon name="tablerMapPin" class="svg-position"></ng-icon>
                Remote
              </div>
              <div *ngIf="JobData?.workMode=='Hybrid'" class="md-job-relocation" title="Hybrid">
                <ng-icon name="tablerMapPin" class="svg-position"></ng-icon>
                Hybrid
              </div>
              <div title="Employer Estimate: {{JobData?.targetRateFrom}} - {{JobData?.targetRateTo}}"
                *ngIf="JobData?.targetRateFrom!=undefined && JobData?.targetRateTo!=undefined" class="md-job-pay">
                Employer estimate:
                <span>
                  {{JobData?.country === 'US' ?
                  '$' :
                  ''}} {{JobData?.targetRateFrom}} - {{JobData?.targetRateTo}}</span>

                <ng-container *ngIf="JobData?.source !== 'CEIPAL'; else ceipalCurMd">
                <span title="{{JobData.country}}" *ngIf="JobData?.country == 'US'"> USD / </span>
                <span title="{{JobData.country}}" *ngIf="JobData?.country == 'IN'"> INR / </span>
                <span title="{{JobData.country}}" *ngIf="JobData?.country == 'CA'"> CAD / </span>
                <span title="{{JobData.country}}" *ngIf="JobData?.country == 'AU'"> AUD / </span>
                <span title="{{JobData.country}}"
                  *ngIf="JobData?.country != 'AU' && JobData?.country != 'US' && JobData?.country != 'CA' && JobData?.country != 'IN'">
                  CUR / </span>
                </ng-container>
                <ng-template #ceipalCurMd>
                  <span title="{{JobData?.currency}}"> {{ getJobCurrency(JobData) }} / </span>
                </ng-template>
                <span title="{{JobData.payType}}" *ngIf="JobData?.payType == 'Hourly'">Hr</span>
                <span title="{{JobData.payType}}" *ngIf="JobData?.payType == 'Daily'">Day</span>
                <span title="{{JobData.payType}}" *ngIf="JobData?.payType == 'Weekly'">Week</span>
                <span title="{{JobData.payType}}" *ngIf="JobData?.payType == 'Monthly'">Month</span>
                <span title="{{JobData.payType}}" *ngIf="JobData?.payType == 'Yearly'">Year</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Timeline section for medium view jobs -->
      <div *ngIf="showTimeline == true" class="timeline-section-001">
        <!-- HORIZONTAL TIMELINE FOR JOBS APPLIED -->
        <div class="horizontal-timeline-004" *ngIf="!timelineIsLoading && mergedTimelineData.length > 0">
          <div class="timeline-event-004" *ngFor='let item of mergedTimelineData; let i = index'>
            <div class="event-card-004" 
                  [ngClass]="{
                    'event-positive-004': item.notion === 'positive',
                    'event-negative-004': item.notion === 'negative', 
                    'event-progress-004': item.notion === 'progress',
                    'event-future-004': item.notion === 'future',
                    'event-default-004': item.notion === 'default'
                  }">
              <div class="event-badge-004"
                    [ngClass]="{
                      'badge-positive-004': item.notion === 'positive',
                      'badge-negative-004': item.notion === 'negative',
                      'badge-progress-004': item.notion === 'progress',
                      'badge-future-004': item.notion === 'future',
                      'badge-default-004': item.notion === 'default'
                    }">
                <!-- Show icons for completed events -->
                <span *ngIf="item.showIcon && item.notion === 'positive'" class="event-icon-004">✓</span>
                <span *ngIf="item.showIcon && item.notion === 'progress'" class="event-icon-004">•</span>
                <span *ngIf="item.showIcon && item.notion === 'negative'" class="event-icon-004">✕</span>
                <!-- Show numbers for future/default events -->
                <span *ngIf="item.showNumber">{{item.order + 1}}</span>
              </div>
              <div class="event-content-004">
                <div class="event-title-004" title="{{item.title}}">
                  {{item.title}}
                </div>
                <div class="event-date-004" *ngIf="item.showDate && item.createdOn">
                  ({{item.createdOn | timezoneDate:'MM/dd/yyyy'}})
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <!-- Loading state with skeletons -->
        <div class="horizontal-timeline-004" *ngIf="timelineIsLoading">
          <div class="timeline-skeleton-004" *ngFor="let n of [1, 2, 3, 4, 5, 6, 7]">
            <app-common-skeleton [NameOftheScreen]="'timeline'"></app-common-skeleton>
          </div>
        </div>
      </div>

      <div class="md-interaction-section"
        [ngClass]="{'disabled':JobData.status=='BLOCKED' || !candidateData?.availability || candidateData?.status != 'ACTIVE', 'click-blocked' : isRoutingDisabled }">
        <div class="md-interaction-element" *ngIf="JobData.jobPostedBy!=userId && JobData.viewedByCount > 0"
          title="{{JobData.viewedByCount}} Views" style="cursor: context-menu;">
          <ng-icon name="tablerEye" class="cursor icon-prime-color"></ng-icon>
          <span class="blue-color">{{ JobData.viewedByCount | compactCount }}</span>
          Views
        </div>
        <div *ngIf="JobData.jobPostedBy!=userId && JobData.viewedByCount == 0" title="0 Views"
          class="md-interaction-element" style="cursor: context-menu;">
          <ng-icon name="tablerEye" class="cursor icon-prime-color"></ng-icon>
          <span class="blue-color">0</span>
          Views
        </div>
        <div id="job_card_medium_views_button" class="md-interaction-element" (click)="goTo(JobData, 'views')"
          *ngIf="JobData.jobPostedBy==userId && JobData.viewedByCount > 0" title="{{JobData.viewedByCount}} Views"
          style="cursor: pointer;">
          <ng-icon name="tablerEye" class="cursor icon-prime-color"></ng-icon>
          <span class="blue-color">{{ JobData.viewedByCount | compactCount }}</span>
          Views
        </div>
        <div id="job_card_medium_no_views_button" class="md-interaction-element" *ngIf="JobData.jobPostedBy==userId && JobData.viewedByCount == 0"
          (click)="goTo(JobData, 'noviews')" title="0 Views">
          <ng-icon name="tablerEye" class="cursor icon-prime-color"></ng-icon>
          <span class="blue-color">0</span>
          Views
        </div>
        <div id="job_card_medium_like_button" class="md-interaction-element" (click)="like(JobData)">
          <div title="Like" *ngIf="!JobData?.isLiked">
            <ng-icon name="tablerHeart" class="pointer icon-prime-color"></ng-icon>
          </div>
          <div title="Unlike" *ngIf="JobData?.isLiked">
            <ng-icon name="tablerHeart" class="liked pointer bg-heart"></ng-icon>
          </div>
        </div>
        <div id="job_card_medium_likes_count_button" class="md-interaction-element" title="{{JobData.likesCount}} Likes" *ngIf="JobData.jobPostedBy==userId"
          (click)="goTo(JobData, 'jobs-liked')">
          <span class="blue-color" *ngIf="JobData.likesCount>0">{{ JobData.likesCount | compactCount }}</span>
          <span *ngIf="JobData.likesCount>0"> Like<span *ngIf="JobData.likesCount>1">s
            </span> </span>
          <div title="0 Likes" class="no-views" *ngIf="JobData.jobPostedBy==userId && JobData.likesCount == 0"
            style="cursor: context-menu!important;"><span class="blue-color" title="0 Likes"> 0 </span> Likes
          </div>
        </div>
        <div class="md-interaction-element" title="{{JobData.likesCount}} Likes" *ngIf="JobData.jobPostedBy!=userId"
          style="cursor: context-menu!important;">
          <span class="blue-color" *ngIf="JobData.likesCount>0">{{ JobData.likesCount | compactCount }}</span>
          <span *ngIf="JobData.likesCount>0"> Like<span *ngIf="JobData.likesCount>1">s </span> </span>
          <div title="0 Likes" class="no-views" *ngIf="JobData.jobPostedBy!=userId && JobData.likesCount == 0"
            style="cursor: context-menu!important;"><span class="blue-color" title="0 Likes"> 0 </span> Likes
          </div>
        </div>

        <div class="md-interaction-element" *ngIf="JobData.jobPostedBy!=userId">
          <ng-icon name="tablerUsers"></ng-icon>
          <span title="{{JobData.appliedCount}} Applicants" class="blue-color"
            *ngIf="JobData.appliedCount>0">{{ JobData.appliedCount | compactCount }}</span>
          <span title="0 Applicants" class="blue-color" *ngIf="JobData?.appliedCount==0 ||JobData?.appliedCount==null">
            0
          </span>
          Applicants
        </div>


        <div id="job_card_medium_applied_count_button" class="md-interaction-element" (click)="goTo(JobData,'candidate-applied')"
          *ngIf="JobData.jobPostedBy==userId">
          <ng-icon name="tablerUsers"></ng-icon>
          <span title="{{JobData.appliedCount}} Applicants" class="blue-color"
            *ngIf="JobData.appliedCount>0">{{ JobData.appliedCount | compactCount }}</span>
          <span title="0 Applicants" class="blue-color" *ngIf="JobData?.appliedCount==0 ||JobData?.appliedCount==null">
            0
          </span>
          Applicants
        </div>


        <div id="job_card_medium_apply_button" title="Apply" class="md-interaction-element"
          (click)="apply(JobData, connectionTemplate, candidateSupplyTemplate)"
          [ngClass]="{'disabled': JobData.status!='ACTIVE'}" *ngIf=" JobData.jobPostedBy!=userId && (userType == 'BENCH_RECRUITER'
          || userType == 'student' || userType == 'JOB_SEEKER'
          || userType == 'FREELANCE_RECRUITER' || userType == 'MANAGEMENT_TALENT_ACQUISITION')">
          <ng-icon name="tablerSend"></ng-icon>
          <div>
            Apply
          </div>
        </div>


        <div id="job_card_medium_chat_with_messages" class="md-interaction-element" *ngIf=" JobData.chatHistoryCount > 0"
          title="{{JobData.nonSeenMessageCount}} Messages" style="cursor: context-menu;"
          (click)="openMessagecheckInteraction(JobData, connectionTemplate)">
          <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="icon-prime-color chat-icon"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path></svg>
          <span class="blue-color" *ngIf="JobData.nonSeenMessageCount>0">{{JobData.nonSeenMessageCount}}</span>
          Chat
        </div>
        <div id="job_card_medium_chat_no_messages" class="md-interaction-element" *ngIf="JobData.jobPostedBy!=userId && JobData.chatHistoryCount == 0"
          (click)="openMessagecheckInteraction(JobData, connectionTemplate)" title="No Messages" style="cursor: context-menu;">
          <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="icon-prime-color chat-icon"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path></svg>
          Chat
        </div>
        <div class="md-interaction-element" *ngIf="JobData.jobPostedBy==userId && JobData.chatHistoryCount == 0"
          title="No Messages" style="cursor: context-menu;">
          <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="icon-prime-color chat-icon"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path></svg>
          Chat
        </div>
      </div>
    </div>
  </div>
</ng-container>

<ng-template #template>
  <div class="common-header-flex">
    <div> Resume Upload </div>
    <button>
      <span id="job_card_resume_close_button" (click)="hide()" class="common-close">×</span>
    </button>
  </div>
  <div class="panel-body">
    <div  class="col-sm-12" style="margin-top: 17px;">
      <div class="dropdox-908"
           appDnd
           (fileDropped)="onFileDropped($event)"
           for="fileDropRef">
        <input
          #fileDropRef
          style="display: none"
          type="file"
          accept=".pdf,.doc,.docx,.txt"
          id="fileDropRef"
          (click)="fileDropRef.value=''"
          (change)="fileBrowseHandler($event.target.files)" />

        <div class="file-icon-908">
          <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
            <polyline points="14 2 14 8 20 8"></polyline>
            <line x1="12" y1="18" x2="12" y2="12"></line>
            <line x1="9" y1="15" x2="15" y2="15"></line>
          </svg>
        </div>
        <div>
          <label class="upload-title-908" for="fileDropRef">Upload Your Resume</label>
        </div>
        <div>
          <label class="upload-instruction-908" for="fileDropRef" id="aad">Drag your files here or click in this area.</label>
        </div>
        <div for="fileDropRef">
          <small class="upload-hint-908">Only PDF, DOCX, DOC, and TXT file formats supported.</small>
        </div>
        <div *ngIf="fileDragdrop" class="file-preview-908 file-preview-entered-908">
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M13 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z"></path>
            <polyline points="13 2 13 9 20 9"></polyline>
          </svg>
          <span class="file-name-908" [title]="fileDragdrop?.fileName || fileDragdrop?.name">{{fileDragdrop?.fileName || fileDragdrop?.name}}</span>
          <ng-icon name="tablerX" id="job_card_remove_file_button" class="file-remove-908" (click)="removeFiles()"></ng-icon>
        </div>
      </div>
    </div>
    <!-- <div class="col-sm-12" style="margin-top: 17px;">
      <label style="margin-left: 17rem;">Do you want to Upload Resume?</label>
 
      <div class="dropdox-908" appDnd (fileDropped)="onFileDropped($event)" for="fileDropRef">
        <input #fileDropRef style="display: none" type="file" accept=".pdf,.doc,.docx,.txt" id="fileDropRef"
          (click)="fileDropRef.value=''"
          (change)="fileBrowseHandler($event.target.files)" />
        <i class="file-icon-908"></i>
        <div>
          <label class="upload-title-908" for="fileDropRef">Upload Your Resume</label>
        </div>
        <div>
          <label class="upload-instruction-908" for="fileDropRef" id="aad">Drag your files here or click in this area.</label>
        </div>
        <div>
          <small class="upload-hint-908">Only PDF, DOCX, DOC, and TXT file formats supported.</small>
        </div>
      </div>
      <div *ngIf="fileDragdrop" class="file-preview-908 file-preview-entered-908">
        <span class="file-name-908">{{fileDragdrop?.name | truncate: 28}}</span>
        <ng-icon name="tablerX" id="job_card_remove_file_button2" class="svg-position file-remove-908"  (click)="removeFiles()"></ng-icon>
        <button id="job_card_remove_file_button3" class="file-remove-908" (click)="removeFiles()">×</button>
      </div>
    </div> -->
    <!-- <div class="files-list" *ngIf="fileDragdrop">
      <div class="upFileWrap">
        <div class="fileUPinfo">
          <ng-icon name="tablerNews"></ng-icon>
          <h4 class="name"> {{ fileDragdrop?.name }} </h4>
          <p id="job_card_download_button" title="Download" class="cursor-pointer top-eye" (click)="onDownload()">
            <ng-icon name="tablerDownload" aria-hidden="true"></ng-icon>
          </p>
          <div id="job_card_remove_file_button4" title="Remove File" (click)="removeFiles()" class="tiimes">x</div>
        </div>
      </div>
    </div> -->
  </div>

  <div class="custom-panel-footer">
    <div class="panel-footer">
      <div class="footer-flex">
        <button id="job_card_cancel_button" class="btn btn-default" (click)="hide()">Cancel </button>
        <button id="job_card_save_button" class="btn  btn-primary" (click)="submit()">Save </button>
      </div>
    </div>
  </div>


</ng-template>
<app-message-widget *ngIf="messagemodelflag" (closeMessageModel)="closeMessage($event)" [messageDataPass]="messageData">
</app-message-widget>
<ng-template #noResult>
  <div class="wert">
    <div class="col-md-12 mg-bt-9">
      <img style=" max-height: 9rem;" src="assets/icon/nothing_found.png" alt="">
    </div>
    <div class="col-md-12 fig">{{jobsFoundStatus}} </div>
  </div>
</ng-template>
<ng-template #RTRtemplate>

  <div class="common-header-flex">
    <div> Rate Confirmation </div>
    <button>
      <span id="job_card_rtr_close_button" (click)="hide()" class="common-close">×</span>
    </button>
  </div>

  <div class="col-sm-12 p-0 white">
    <div class="col-sm-12 p-0">

      <div [formGroup]="rtrformgrp">
        <div class="RtrForm payrate-two-row">

          <div class="payrate-row">
            <div class="payrate-row-label">Submitted for</div>
            <div class="targetRate">
              <input type="text" class="form-control input-sm payrate-readonly"
                     formControlName="submittedToRate" readonly tabindex="-1" />
            </div>
            <div class="paytype">
              <select class="form-control input-sm payrate-readonly"
                      formControlName="submittedRateType" disabled tabindex="-1">
                <option value="Hourly">Hourly</option>
                <option value="Daily">Daily</option>
                <option value="Weekly">Weekly</option>
                <option value="Monthly">Monthly</option>
                <option value="Yearly">Yearly</option>
              </select>
            </div>
          </div>

          <div class="payrate-row">
            <div class="payrate-row-label">Offer for</div>
            <div class="targetRate">
              <input maxlength="8" #rtrvalue (keypress)="isInteger($event)" type="text"
                class="form-control input-sm" formControlName="offerRate" placeholder="Ex: 10000.." />
              <span *ngIf="rtrFormControls.offerRate.errors?.required &&
                (rtrFormControls.offerRate?.dirty || rtrFormControls.offerRate?.touched)" class="error">Please enter the value</span>
              <span *ngIf="rtrFormControls.offerRate.errors?.invalidDecimal" class="error">Enter valid offer rate</span>
              <span *ngIf="rtrFormControls.offerRate.errors?.max" class="error">
                Offer cannot exceed submitted ceiling of {{ rtrformgrp.get('submittedToRate')?.value }}
              </span>
            </div>
            <div class="paytype">
              <select formControlName="offerRateType" class="form-control input-sm">
                <option value="Hourly">Hourly</option>
                <option value="Daily">Daily</option>
                <option value="Weekly">Weekly</option>
                <option value="Monthly">Monthly</option>
                <option value="Yearly">Yearly</option>
              </select>
              <span class="error" *ngIf="rtrFormControls.offerRateType.errors?.required &&
                (rtrFormControls.offerRateType?.dirty || rtrFormControls.offerRateType?.touched)">Please select pay type</span>
            </div>
          </div>

          <div class="currency">
            <span *ngIf="rtrformgrp.value?.country === 'US'"> USD </span>
            <span *ngIf="rtrformgrp.value?.country === 'IN'"> INR </span>
            <span *ngIf="rtrformgrp.value?.country === 'CA'"> CAD </span>
            <span *ngIf="rtrformgrp.value?.country === 'DZ'"> AUD </span>
          </div>

          <div class="tAndCdesign">
            <div class="custom-checkbox em">
              <label class="checkbox-label font-normal" style="text-align: center">
                I warrant that I have an exclusive right to represent this candidate for the
                applied position
                <input type="checkbox" class="termsCondition" formControlName="termsandcondition" id="termsCheckBoxs" />
                <span class="checkmark"></span>
              </label>
            </div>
          </div>

        </div>
        <div class="t-c-error-msg"
          *ngIf="rtrFormControls.termsandcondition.invalid && (rtrFormControls.termsandcondition.touched)">
          Please accept to the above statement by checking it
        </div>
      </div>

      <!-- <div class="resumeUpload" *ngIf="showResumeUpload &&  !candidateData.resumeAttached">
        <div class="dropdox" appDnd (fileDropped)="onFileDropped($event)">
          <input style="display: none" accept=".pdf,.doc,.docx,.txt" type="file" #fileDropRef id="fileDropRef"
            (change)="fileBrowseHandler($event.target.files)" />
          <div>
            <div>
              <label class="file-boreder resumeTitle" for="fileDropRef">Upload Your Resume</label>
              <label class="file-boreder" id="aad" for="fileDropRef">Drag your files here or click in this area.</label>
            </div>
          </div>
          <div>
            <small>Only PDF, DOCX, DOC, and TXT file formats supported.</small>
          </div>
        </div>
      </div> -->
  <div *ngIf="showResumeUpload &&  !candidateData.resumeAttached" class="pd-3rem">
    <div class="dropdox-908"
    appDnd
    (fileDropped)="onFileDropped($event)"
    for="fileDropRef">
     <input
       #fileDropRef
       style="display: none"
       type="file"
       accept=".pdf,.doc,.docx,.txt"
       id="fileDropRef"
       (click)="fileDropRef.value=''"
       (change)="fileBrowseHandler($event.target.files)" />

     <div class="file-icon-908">
       <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
         <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
         <polyline points="14 2 14 8 20 8"></polyline>
         <line x1="12" y1="18" x2="12" y2="12"></line>
         <line x1="9" y1="15" x2="15" y2="15"></line>
       </svg>
     </div>
     <div>
       <label class="upload-title-908" for="fileDropRef">Upload Your Resume</label>
     </div>
     <div>
       <label class="upload-instruction-908" for="fileDropRef" id="aad">Drag your files here or click in this area.</label>
     </div>
     <div for="fileDropRef">
       <small class="upload-hint-908">Only PDF, DOCX, DOC, and TXT file formats supported.</small>
     </div>
     <div *ngIf="fileDragdrop" class="file-preview-908 file-preview-entered-908">
       <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
         <path d="M13 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z"></path>
         <polyline points="13 2 13 9 20 9"></polyline>
       </svg>
       <span class="file-name-908" [title]="fileDragdrop?.fileName || fileDragdrop?.name">{{fileDragdrop?.fileName || fileDragdrop?.name}}</span>
       <ng-icon name="tablerX" id="job_card_rtr_remove_file_button" class="file-remove-908" (click)="removeFiles()"></ng-icon>
     </div>
   </div>
  </div>

      <!-- <div class="files-list" *ngIf="fileDragdrop">
        <div class="single-file">
          <div class="info">
            <h4 class="name">
              {{ fileDragdrop?.name }}
            </h4>
            <p id="job_card_rtr_download_button" title="Download" class="cursor-pointer top-eye" (click)="onDownload()">
              <ng-icon name="tablerDownload" aria-hidden="true"></ng-icon>
            </p>
            <div id="job_card_rtr_remove_file_button2" (click)="removeFiles()" title="Remove File" class="tiimes">x</div>
          </div>
        </div>
      </div> -->

    </div>
  </div>

  <div class="custom-panel-footer col-sm-12 p-0">
    <div class="panel-footer">
      <div class="footer-flex">
        <button id="job_card_rtr_cancel_button" class="btn btn-default " (click)="hide()">Cancel </button>
        <button id="job_card_rtr_submit_button" class="btn  btn-primary " (click)="submit()"> Submit </button>
      </div>
    </div>
  </div>

</ng-template>

<!-- ═══════════════════════════════════════════════════════════════════════
     PAYRATE popup — restored pre-redesign single-field design (Rate + Pay
     Type). Bound to the isolated `payrategrp`; wired ONLY to the V3
     job-invite ACCEPT (jb_dpDown_v3_1). The two-row #RTRtemplate above is
     left intact and untouched for the other card views.
     ═══════════════════════════════════════════════════════════════════════ -->
<ng-template #payrateTemplate>

  <div class="common-header-flex">
    <div> Rate Confirmation </div>
    <button>
      <span id="job_card_payrate_close_button" (click)="hidePayrate()" class="common-close">×</span>
    </button>
  </div>

  <div class="col-sm-12 p-0 white">
    <div class="col-sm-12 p-0">

      <div [formGroup]="payrategrp">
        <div class="RtrForm payrate-single-row">
          <div class="targetRate">
            <label for="" style="margin-left: 2px;"> Rate</label>
            <div class="input-wrapper">
              <input maxlength="8" #payratevalue (keypress)="isInteger($event)" type="text"
                class="form-control input-sm " formControlName="targetrate" placeholder="Ex: 10000.." />
              <span class="currency-label">
                <span *ngIf="payrategrp.value?.country === 'US'">USD</span>
                <span *ngIf="payrategrp.value?.country === 'IN'">INR</span>
                <span *ngIf="payrategrp.value?.country === 'CA'">CAD</span>
                <span *ngIf="payrategrp.value?.country === 'DZ'">AUD</span>
                <span *ngIf="!payrategrp.value?.country">USD</span>
              </span>
            </div>
            <span *ngIf="payrateFormControls.targetrate.errors?.required &&
            (payrateFormControls.targetrate?.dirty || payrateFormControls.targetrate?.touched)" class="error ">Please enter the
              value</span>
            <span *ngIf="payrateFormControls.targetrate.errors?.invalidDecimal" class="error ">Enter valid target rate
            </span>

          </div>
          <div class="paytype">
            <label for=""> Pay Type</label>
            <select type="text" formControlName="RtrpayType" class="form-control input-sm">
                    <option value="" disabled selected hidden>Select pay type</option>
              <option value="Hourly">Hourly</option>
              <option value="Daily">Daily</option>
              <option value="Weekly">Weekly</option>
              <option value="Monthly">Monthly</option>
              <option value="Yearly">Yearly</option>
            </select>
            <span class="error" *ngIf="payrateFormControls.RtrpayType.errors?.required &&
              (payrateFormControls.RtrpayType?.dirty || payrateFormControls.RtrpayType?.touched) ">Please select pay type</span>
          </div>
          <div class="tAndCdesign">

            <div class="custom-checkbox em">
              <label class="checkbox-label font-normal" style="text-align: center">
                I warrant that I have an exclusive right to represent this candidate for the
                applied position
                <input type="checkbox" class="termsCondition" formControlName="termsandcondition" id="payrateTermsCheckBox" />
                <span class="checkmark"></span>
              </label>
            </div>

          </div>

        </div>
        <div class="t-c-error-msg"
          *ngIf="payrateFormControls.termsandcondition.invalid && (payrateFormControls.termsandcondition.touched)">
          Please accept to the above statement by checking it
        </div>
      </div>

      <div *ngIf="showResumeUpload &&  !candidateData.resumeAttached" class="pd-3rem">
        <div class="dropdox-908"
        appDnd
        (fileDropped)="onFileDropped($event)"
        for="payrateFileDropRef">
         <input
           #payrateFileDropRef
           style="display: none"
           type="file"
           accept=".pdf,.doc,.docx,.txt"
           id="payrateFileDropRef"
           (click)="payrateFileDropRef.value=''"
           (change)="fileBrowseHandler($event.target.files)" />

         <div class="file-icon-908">
           <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
             <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
             <polyline points="14 2 14 8 20 8"></polyline>
             <line x1="12" y1="18" x2="12" y2="12"></line>
             <line x1="9" y1="15" x2="15" y2="15"></line>
           </svg>
         </div>
         <div>
           <label class="upload-title-908" for="payrateFileDropRef">Upload Your Resume</label>
         </div>
         <div>
           <label class="upload-instruction-908" for="payrateFileDropRef" id="payrateUploadHint">Drag your files here or click in this area.</label>
         </div>
         <div for="payrateFileDropRef">
           <small class="upload-hint-908">Only PDF, DOCX, DOC, and TXT file formats supported.</small>
         </div>
         <div *ngIf="fileDragdrop" class="file-preview-908 file-preview-entered-908">
           <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
             <path d="M13 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z"></path>
             <polyline points="13 2 13 9 20 9"></polyline>
           </svg>
           <span class="file-name-908" [title]="fileDragdrop?.fileName || fileDragdrop?.name">{{fileDragdrop?.fileName || fileDragdrop?.name}}</span>
           <ng-icon name="tablerX" id="job_card_payrate_remove_file_button" class="file-remove-908" (click)="removeFiles()"></ng-icon>
         </div>
       </div>
      </div>

    </div>
  </div>

  <div class="custom-panel-footer col-sm-12 p-0">
    <div class="panel-footer">
      <div class="footer-flex">
        <button id="job_card_payrate_cancel_button" class="btn btn-default " (click)="hidePayrate()">Cancel </button>
        <button id="job_card_payrate_submit_button" class="btn  btn-primary " (click)="submitPayrate()"> Submit </button>
      </div>
    </div>
  </div>

</ng-template>
<ng-template #connectionTemplate>
  <app-connection-template [page]="'job-card'" [connectionStatus]="connectionStatus"
    [counterpartsDetails]="counterpartsDetails" [values]="values" [module]="'job'"></app-connection-template>
</ng-template>

<ng-template #candidateSupplyTemplate>
  <ng-container>
    <div class="row mr-0">
      <div class="col-sm-8 pad-lt-rt-0">
        <div class="xs-heading-flex-parent">
          <div class="xs-heading-entity">My Candidates</div>
          <div class="xs-heading-payrate">Pay Rate</div>
          <div class="xs-heading-paytype">Type</div>
        </div>
        <div class="xs-body-container" infiniteScroll [infiniteScrollDistance]="2" [infiniteScrollThrottle]="300"
          [scrollWindow]="false">
          <!-- Dynamic component container for CandidatesPageComponent (circular dependency fix) -->
          <!-- Using div with ID so we can query it from the modal's DOM after modal renders -->
          <div #candidatesPageContainer id="candidatesPageDynamicContainerJobCard"></div>
        </div>
        <div class="xs-footer-container"></div>
      </div>
      <div class="col-sm-4 pad-lt-0 pad-rt-0">
        <!-- `data-gs-cards="native"` opts this subtree out of the global
             `_section-card.scss` legacy card styling so the Job Details
             panel renders in the same clean native look as the Invite
             popup's Candidate Details panel (new-job.component.html:457). -->
        <div class="hpanel" data-gs-cards="native"
             style="margin-bottom: 0px !important;border-radius: 20px 9px 9px 20px !important;">
          <div class="hpanel-heading xs-heading-flex-entity-detail">
            <div>Job Details</div>
            <button><span id="job_card_candidate_supply_close_button" class="modalai-close" aria-hidden="true"
                (click)="closeCandidateSupplyModal()">&times;</span></button>
          </div>
          <app-job-submit-skillfilter [focus]="'job'" [jobData]="jobData" [termsChecked]="termsCheck"
            [resumes]="resumeData" [formData]="rtrFormData" [dataPasstoSkillwidgets]="dataPasstoSkillwidgets"
            (emitRemoveTag)="removeUserfromTag($event)">
          </app-job-submit-skillfilter>
        </div>
      </div>
    </div>
  </ng-container>
</ng-template>


<ng-container *ngIf="showDocumentSection">
  <app-candidate-documents
    [pageName]="'job-card'"
    [isOpen]="showDocumentSection"
    [listOfDocuments]="typeOfDocuments"
    [candidateId]="candidateData?.candidateId"
    [jobId]="JobData?.jobId"
    [count]="totalMandatoryDocuments ?? 0"
    (close)="closeDocuments()"
    (save)="saveDocuments()"
    (dataChanged)="refreshDocumentData()">
  </app-candidate-documents>
</ng-container>

<!-- Row Design ViewSize - Table Row Layout -->
<ng-container *ngIf="viewSize == 'row-design'">
  <div class="job-row" [ngClass]="{
    'disabled': !JobData?.availability || JobData?.status != 'ACTIVE' || !candidateData?.availability || candidateData?.status != 'ACTIVE',
    'featured-background': JobData?.isFeatured === true}">

    <!-- Rank Column -->
    <div class="table-cell rank-col">
      <div class="rank-circle">{{indexInput + 1}}</div>
    </div>

    <!-- Company/User Column -->
    <div class="table-cell company-col" (click)="openJobInSlidePanel(JobData)">
      <div class="company-info">
        <div class="company-avatar" *ngIf="JobData?.user?.photo!=undefined && JobData?.user?.photo!=null && JobData?.user?.photo!='' && JobData?.user?.photo!='null'">
          <img  [src]="url + JobData?.user?.photo" alt="profile-picture" (error)="$event.target.style.display='none'">
        </div>
        <div class="company-avatar" *ngIf=" JobData?.user?.photo == undefined || JobData?.user?.photo == null || JobData?.user?.photo == '' || JobData?.user?.photo == 'null'">
          <div class="avatar-initials"
            [style.background-color]="getColor(JobData?.user?.fullname)"
            [style.color]="getFullNameTextColor(JobData?.user?.fullname)">
            {{getInitials(JobData?.user?.fullname)}}
          </div>
        </div>
        <div class="company-details">
          <div class="company-name"  style="cursor: pointer;">{{JobDataUser?.fullname}}</div>
          <div class="company-title">{{getCurrentOrganizationName(JobData)}}</div>
          <div class="company-location">{{JobData?.city}}<span *ngIf="JobData?.city && JobData?.state">, </span>{{JobData?.state}}</div>
          <div *ngIf="JobData?.latest && JobData.latest == true" class="latest-badge">New</div>
          <div class="label-tag" [ngStyle]="getStyle('INACTIVE')" style="line-height: 16px;"
            *ngIf="(JobData?.status != 'ACTIVE'||!JobData?.availability)">
            {{ JobData?.status != 'ACTIVE' ? convertSmallCase(JobData?.status) : 'On Hold' }}
          </div>
          <!-- CEIPAL Badge -->
          <!-- <div *ngIf="JobData?.source == 'CEIPAL'" title="From Ceipal" style="margin-top: 4px;">
            <img src="assets/images/ceipal1.png" alt="ceipal" style="height: 18px; width: auto; border-radius: 50%;" />
          </div> -->
        </div>
      </div>
    </div>

    <!-- Job Title & Location Column -->
    <div class="table-cell job-location-col">
      <div class="job-location-info">
        <div class="job-title-text">
          {{JobData?.jobTitle}}
        </div>
        <div class="job-id-text">
          Job ID: {{JobData?.jobId}}
        </div>
        <div class="job-type-text" *ngIf="userTypeMap[JobData?.employmentType]">
          {{ userTypeMap[JobData?.employmentType] }}
        </div>
        <div class="badge-row">
          <div class="work-mode-badge" *ngIf="JobData?.workMode">
            {{JobData?.workMode}}
          </div>
          <div class="status-badge" *ngIf="JobData?.status"
            [ngStyle]="getStyle(JobData?.status)">
            {{ convertSmallCase(JobData?.status) }}
          </div>
          <div class="urgent-hire-badge-compact" *ngIf="getActiveUrgencyDays(JobData)">
            <ng-icon name="tablerFlame" style="font-size: 9px;"></ng-icon> Urgent Hire - {{getActiveUrgencyDays(JobData)}}d
          </div>
        </div>
      </div>
    </div>

    <!-- Skills Column -->
    <div class="table-cell skills-col">
      <div class="skills-container" *ngIf="!JobData.showAllSkills">
        <span class="skill-tag primary-skill text-primary-2" *ngFor="let skill of getAllSkills(JobData).slice(0, 2)"
          [ngStyle]="{ 'border-radius': getBorderRadius(skill) }">
          {{skill}}
        </span>
        <span class="skill-count text-primary-2" 
          *ngIf="getAllSkills(JobData).length > 2"
          (click)="toggleSkills(JobData)">
          +{{ getAllSkills(JobData).length - 2 }}
        </span>
      </div>
      <div class="skills-container expanded" *ngIf="JobData.showAllSkills">
        <span class="skill-tag primary-skill text-primary-2" *ngFor="let skill of getAllSkills(JobData)"
          [ngStyle]="{ 'border-radius': getBorderRadius(skill) }">
          {{skill}}
        </span>
        <!-- <span class="skill-tag secondary-skill text-primary-2" *ngFor="let skill of JobData?.secondarySkills">
          {{skill}}
        </span> -->
        <span class="skill-collapse" (click)="toggleSkills(JobData)">
          Show less
        </span>
      </div>
    </div>

    <!-- Match Column -->
    <div class="table-cell match-col">
      <div class="match-score">
        <span class="match-percent text-primary-2" *ngIf="pageFrom != 'suggestedJobs'">
          {{ (JobData?.matchingScore != null && JobData?.matchingScore != 0) ? (JobData?.matchingScore % 1 === 0 ? JobData?.matchingScore + '%' : (JobData?.matchingScore | number:'1.2-2') + '%') : '-' }}
        </span>
        <span class="match-percent text-primary-2" *ngIf="pageFrom == 'suggestedJobs'">
          {{ JobData?.score != null ?  JobData?.score + '%' : '-' }}
        </span>
      </div>
      <img *ngIf="JobData?.matchingScore != null && JobData?.matchingScore != 0 && pageFrom != 'suggestedJobs'"
        src="../../../../assets/images/details icon.png" alt="" style="height: 33px; width: 33px; cursor:pointer !important;"
        (click)="openPercentageDetails(JobData)">

      <img *ngIf="JobData?.score != null && JobData?.score != 0 && pageFrom == 'suggestedJobs'"
        src="../../../../assets/images/details icon.png" alt="" style="height: 33px; width: 33px; cursor:pointer !important;"
        (click)="openPercentageDetails(JobData)">
    </div>

    <!-- Engagement Column -->
    <div class="table-cell engagement-col">
      <div class="engagement-stats">
        <div class="stat-item">
          <!-- <ng-icon name="tablerEye"></ng-icon> {{JobData?.viewedByCount || 0}} Views -->
          <div class="" *ngIf="JobData.jobPostedBy!=userId && JobData.viewedByCount > 0"
            title="{{JobData.viewedByCount}} Views" style="cursor: context-menu;">
            <ng-icon name="tablerEye" class="cursor icon-prime-color"></ng-icon>
            <span class="blue-color">{{ JobData.viewedByCount | compactCount }}</span>
            Views
          </div>
          <div *ngIf="JobData.jobPostedBy!=userId && JobData.viewedByCount == 0" title="0 Views"
            class="" style="cursor: context-menu;">
            <ng-icon name="tablerEye" class="cursor icon-prime-color"></ng-icon>
            <span class="blue-color">0</span>
            Views
          </div>
          <div id="job_card_medium_views_button" class="" (click)="goTo(JobData, 'views')"
            *ngIf="JobData.jobPostedBy==userId && JobData.viewedByCount > 0" title="{{JobData.viewedByCount}} Views"
            style="cursor: pointer;">
            <ng-icon name="tablerEye" class="cursor icon-prime-color"></ng-icon>
            <span class="blue-color">{{ JobData.viewedByCount | compactCount }}</span>
            Views
          </div>
          <div id="job_card_medium_no_views_button" class="" *ngIf="JobData.jobPostedBy==userId && JobData.viewedByCount == 0"
            (click)="goTo(JobData, 'noviews')" title="0 Views">
            <ng-icon name="tablerEye" class="cursor icon-prime-color"></ng-icon>
            <span class="blue-color">0</span>
            Views
          </div>
        </div>

        <!-- <ng-icon name="tablerUsers"></ng-icon> {{JobData?.appliedCount || 0}} Applied -->
        <!-- <div class="stat-item">
          <div class="md-interaction-element" *ngIf="JobData.jobPostedBy!=userId">
            <ng-icon name="tablerUsers"></ng-icon>
            <span title="{{JobData.appliedCount}} Applicants" class="blue-color"
              *ngIf="JobData.appliedCount>0">{{JobData.appliedCount}}</span>
            <span title="0 Applicants" class="blue-color" *ngIf="JobData?.appliedCount==0 ||JobData?.appliedCount==null">
              0
            </span>
            Applicants
          </div>


          <div id="job_card_medium_applied_count_button" class="md-interaction-element" (click)="goTo(JobData,'candidate-applied')"
            *ngIf="JobData.jobPostedBy==userId">
            <ng-icon name="tablerUsers"></ng-icon>
            <span title="{{JobData.appliedCount}} Applicants" class="blue-color"
              *ngIf="JobData.appliedCount>0">{{JobData.appliedCount}}</span>
            <span title="0 Applicants" class="blue-color" *ngIf="JobData?.appliedCount==0 ||JobData?.appliedCount==null">
              0
            </span>
            Applicants
          </div>         
        </div> -->

        <div class="stat-item">
          <div id="job_card_medium_like_button" class="md-interaction-element" (click)="like(JobData)">
            <div title="Like" *ngIf="!JobData?.isLiked">
              <ng-icon name="tablerHeart" class="pointer icon-prime-color"></ng-icon>
            </div>
            <div title="Unlike" *ngIf="JobData?.isLiked">
              <ng-icon name="tablerHeart" class="liked pointer bg-heart"></ng-icon>
            </div>
          </div>
          <div id="job_card_medium_likes_count_button" class="md-interaction-element" title="{{JobData.likesCount}} Likes" *ngIf="JobData.jobPostedBy==userId"
            (click)="goTo(JobData, 'jobs-liked')">
            <span class="blue-color" *ngIf="JobData.likesCount>0">{{ JobData.likesCount | compactCount }}</span>
            <span *ngIf="JobData.likesCount>0"> Like<span *ngIf="JobData.likesCount>1">s
              </span> </span>
            <div title="0 Likes" class="no-views" *ngIf="JobData.jobPostedBy==userId && JobData.likesCount == 0"
              style="cursor: context-menu!important;"><span class="blue-color" title="0 Likes"> 0 </span> Likes
            </div>
          </div>
          <div class="md-interaction-element" title="{{JobData.likesCount}} Likes" *ngIf="JobData.jobPostedBy!=userId"
            style="cursor: context-menu!important;">
            <span class="blue-color" *ngIf="JobData.likesCount>0">{{ JobData.likesCount | compactCount }}</span>
            <span *ngIf="JobData.likesCount>0"> Like<span *ngIf="JobData.likesCount>1">s </span> </span>
            <div title="0 Likes" class="no-views" *ngIf="JobData.jobPostedBy!=userId && JobData.likesCount == 0"
              style="cursor: context-menu!important;"><span class="blue-color" title="0 Likes"> 0 </span> Likes
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Salary Column -->
    <div class="table-cell salary-col">
      <div class="salary-info">
        <div title="Employer Estimate: {{JobData?.targetRateFrom}} - {{JobData?.targetRateTo}}"
          *ngIf="JobData?.targetRateFrom!=undefined && JobData?.targetRateTo!=undefined" class="">
         
          <span>
            {{JobData?.country === 'US' ?
            '$' :
            ''}} {{JobData?.targetRateFrom}} - {{JobData?.targetRateTo}}</span>

          <ng-container *ngIf="JobData?.source !== 'CEIPAL'; else ceipalCurTable">
          <span title="{{JobData.country}}" *ngIf="JobData?.country == 'US'"> USD / </span>
          <span title="{{JobData.country}}" *ngIf="JobData?.country == 'IN'"> INR / </span>
          <span title="{{JobData.country}}" *ngIf="JobData?.country == 'CA'"> CAD / </span>
          <span title="{{JobData.country}}" *ngIf="JobData?.country == 'AU'"> AUD / </span>
          <span title="{{JobData.country}}"
            *ngIf="JobData?.country != 'AU' && JobData?.country != 'US' && JobData?.country != 'CA' && JobData?.country != 'IN'">
            CUR / </span>
          </ng-container>
          <ng-template #ceipalCurTable>
            <span title="{{JobData?.currency}}"> {{ getJobCurrency(JobData) }} / </span>
          </ng-template>
          <span title="{{JobData.payType}}" *ngIf="JobData?.payType == 'Hourly'">Hr</span>
          <span title="{{JobData.payType}}" *ngIf="JobData?.payType == 'Daily'">Day</span>
          <span title="{{JobData.payType}}" *ngIf="JobData?.payType == 'Weekly'">Week</span>
          <span title="{{JobData.payType}}" *ngIf="JobData?.payType == 'Monthly'">Month</span>
          <span title="{{JobData.payType}}" *ngIf="JobData?.payType == 'Yearly'">Year</span>
        </div>
      </div>
    </div>

    <!-- Stage Column -->
    <div class="table-cell stage-col"  *ngIf="pageFrom != 'suggestedJobs'">
      <div class="stage-dropdown" dropdown id="jb_dpDown_4" *ngIf="showStatus"
        [ngClass]="{disabled : !candidateData?.availability || candidateData?.status != 'ACTIVE' }">
        <button data-toggle="dropdown" dropdownToggle
          id="candidateInviteActionButton" class="stage-btn"
          (click)="triggerChange(JobData?.jobReferenceId)" aria-expanded="true"
          [style.background-color]="getStageStyle(JobData?.currentStatus || 'APPLIED')?.background"
          [style.color]="getStageStyle(JobData?.currentStatus || 'APPLIED')?.color"
          [style.border]="'1px solid ' + (getStageStyle(JobData?.currentStatus || 'APPLIED')?.background || '#E5E7EB')"> <span> </span>
          <ng-container> {{ getFilterValue(JobData?.currentStatus , 'JOB_INVITE') | titlecase }} </ng-container>
          <ng-container *ngIf="!isExcludedStatus(JobData?.currentStatus , 'JOB_INVITE')">
            <ng-icon name="tablerChevronDown" aria-hidden="true"></ng-icon>
          </ng-container>
        </button>
        <ng-container *ngIf="!isExcludedStatus(JobData?.currentStatus , 'JOB_INVITE')">
          <ul *dropdownMenu class="dropdown-menu stage-menu"  role="menu"
            aria-labelledby="button-animated">

            <li role="menuitem" *ngFor="let statusData of filterApplicant(JobData?.currentStatus , 'JOB_INVITE')"
              id="candidateInvitesubmitbutton" (click)="updatestatus(statusData?.itemId ,JobData,RTRtemplate)"
              id="{{statusData?.item}}"> <a><ng-icon name="tablerCircle" aria-hidden="true"></ng-icon>&nbsp;
                {{statusData?.item | titlecase}}
              </a>
            </li>

          </ul>
        </ng-container>
      </div>

      <div class="stage-dropdown" [ngClass]="{disabled : !candidateData?.availability || candidateData?.status != 'ACTIVE' }" dropdown
        *ngIf="JobData?.status != 'DRAFTED' && !showStatus &&!jobstatus">
        <button id="jb_dpDown_1" class="stage-btn" dropdownToggle
          aria-expanded="true"
          [style.background-color]="getStageStyle(JobData?.currentStatus || 'APPLIED')?.background"
          [style.color]="getStageStyle(JobData?.currentStatus || 'APPLIED')?.color"
          [style.border]="'1px solid ' + (getStageStyle(JobData?.currentStatus || 'APPLIED')?.background || '#E5E7EB')">
          <ng-container
            *ngIf="JobData?.currentStatus === 'INITIATED' || JobData?.currentStatus === 'INTETEREST_SHOWN'">
            Invited </ng-container>
          <ng-container *ngIf="JobData?.currentStatus === 'ACTIVE'"> Active </ng-container>
          <ng-container
            *ngIf="JobData?.currentStatus !== 'INITIATED' && JobData?.currentStatus !== 'INTETEREST_SHOWN'">
            {{ getFilterValue(JobData?.currentStatus) | titlecase }}
          </ng-container>
          <ng-icon name="tablerChevronDown" *ngIf="!isExcludedStatus(JobData?.currentStatus)" 
            aria-hidden="true"></ng-icon>
        </button>
        <ng-container *ngIf="!isExcludedStatus(JobData?.currentStatus)">
          <ul *dropdownMenu class="dropdown-menu stage-menu" role="menu"
            aria-labelledby="jb_dpDown">
            <li role="menuitem" *ngFor="let statusData of filterApplicant(JobData?.currentStatus)"
              (click)="validateNegativeStatus(statusData , JobData)" id="{{statusData?.item}}">
              <a id="{{statusData?.item}}"><ng-icon name="tablerCircle" aria-hidden="true"></ng-icon>&nbsp;
                {{statusData?.item}}
              </a>
            </li>
          </ul>
        </ng-container>
      </div>
    </div>

    <!-- Quick Actions Column -->
    <div class="table-cell actions-col">
      <div class="action-buttons">

        <button class="action-btn11111" title="View Job" (click)="openJobInSlidePanel(JobData)">
          <ng-icon name="tablerEye"></ng-icon>
        </button>

        <button class="action-btn11111" title="Apply Job"
          [ngClass]="{'disabled': JobData.status!='ACTIVE'}" *ngIf=" JobData.jobPostedBy!=userId && (userType == 'BENCH_RECRUITER'
          || userType == 'student' || userType == 'JOB_SEEKER'
          || userType == 'FREELANCE_RECRUITER' || userType == 'MANAGEMENT_TALENT_ACQUISITION')"
          (click)="apply(JobData, connectionTemplate, candidateSupplyTemplate)">
          <!-- <ng-icon name="tablerSend"></ng-icon> -->
           <ng-icon name="tablerHandClick"></ng-icon>
        </button>

        <button class="action-btn11111" title="chat" *ngIf=" JobData.chatHistoryCount > 0">
          <div id="job_card_medium_chat_with_messages" class="md-interaction-element" 
            title="{{JobData.nonSeenMessageCount}} Messages"
            (click)="openMessagecheckInteraction(JobData, connectionTemplate)">
            <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path></svg>
            <span class="blue-color" *ngIf="JobData.nonSeenMessageCount>0">{{JobData.nonSeenMessageCount}}</span>
          </div>
        </button>

        <button class="action-btn11111" title="chat"  *ngIf="JobData.jobPostedBy!=userId && JobData.chatHistoryCount == 0">
          <div id="job_card_medium_chat_no_messages" class="md-interaction-element"
            (click)="openMessagecheckInteraction(JobData, connectionTemplate)" title="No Messages">
            <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path></svg>
          </div>
        </button>

        <button class="action-btn11111" title="chat" *ngIf="JobData.jobPostedBy==userId && JobData.chatHistoryCount == 0">
          <div class="md-interaction-element"
            title="No Messages">
            <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path></svg>
          </div>
        </button>

        <button  *ngIf="['OFFER-ACCEPTED','PRE-ONBOARDED','ONBOARDED'].includes(JobData?.currentStatus) && pageFrom != 'suggestedJobs'"
          class="action-btn11111" title="Candidate Document" (click)="openDocuments()">
          <ng-icon name="tablerFileText"></ng-icon>
          <span *ngIf="JobData.totalMandatoryDocuments > 0" class="doc-count-badge">{{JobData.totalMandatoryDocuments}}</span>
        </button>

        <!-- <button class="action-btn11111" title="More Options"
          *ngIf="pageFrom != 'suggestedJobs'"
          dropdown dropdownToggle>
          <ng-icon name="tablerDots" dropdownToggle></ng-icon>
          <ul *dropdownMenu class="dropdown-menu">
            <li><a (click)="apply()">Apply Now</a></li>
            <li><a (click)="saveJob()">Save Job</a></li>
            <li><a (click)="reportJob()">Report Job</a></li>
          </ul>
        </button> -->

      </div>
    </div>

    <!-- Timeline Progress Bar with Stage-Based Logic (Matches candidate-card row-design) -->
    <!-- <div class="row-design-timeline-progress" *ngIf="showTimeline && JobData?.timelineStages && JobData.timelineStages.length > 0">
      <div class="row-design-timeline-track">
        <ng-container *ngFor="let stage of JobData.timelineStages; let i = index; let last = last">
          <div class="row-design-timeline-step"
               [class.completed]="stage.completed"
               [class.active]="stage.active"
               [class.negative]="stage.isNegative"
               [class.terminal]="stage.isTerminal"
               [class.implied]="stage.isImplied"
               [class.future]="stage.notion === 'future'"
               [title]="stage.isImplied && stage.date ? (stage.label + ' - Skipped (reached higher stage on ' + (stage.date | timezoneDate:'dd MMM yyyy') + ')') : (stage.isImplied ? (stage.label + ' - Skipped (implied completion)') : (stage.completed && stage.date ? (stage.label + ' - Completed on ' + (stage.date | timezoneDate:'dd MMM yyyy')) : (stage.label + (stage.activityType ? ' (' + stage.activityType + ')' : ''))))">
            <div class="row-design-step-dot">
              <ng-icon name="tablerCheck" *ngIf="stage.completed && !stage.isTerminal"></ng-icon>
            </div>
            <span class="row-design-step-label">
              {{stage.label}}
            </span>
            <span class="row-design-step-date" *ngIf="stage.date">
              {{stage.date | date:'dd MMM yyyy'}}
            </span>
          </div>
          <div class="row-design-timeline-connector"
               *ngIf="!last"
               [class.completed]="JobData?.timelineStages[i + 1]?.completed && !stage.isTerminal"
               [class.negative]="stage.isNegative"></div>
        </ng-container>
      </div>
    </div> -->

    <!-- Timeline Progress Bar with Stage-Based Logic -->
    <!-- 🔄 Loading shimmer timeline -->
    <div class="row-design-timeline-progress loading"  *ngIf="isTimelineLoading; else timelineContent">
      <div class="row-design-timeline-track">
        <ng-container *ngFor="let stage of defaultTimelineSkeleton; let i = index; let last = last">
          <div class="row-design-timeline-step loading-step"
              [title]="stage.label">
            <div class="row-design-step-dot loading-dot"
                [style.--delay]="i">
            </div>
            <span class="row-design-step-label ">
              {{stage.label}}
            </span>
            <span class="row-design-step-date ">
              &nbsp;
            </span>
          </div>
          <div class="row-design-timeline-connector loading-connector"
              *ngIf="!last"></div>
        </ng-container>
      </div>
    </div>

    <!-- ✅ Actual timeline -->
    <ng-template #timelineContent>
      <div class="row-design-timeline-progress" *ngIf="showTimeline && timelineDataGrouped && timelineDataGrouped.length > 0">
        <div class="row-design-timeline-track">
          <ng-container *ngFor="let stage of timelineDataGrouped; let i = index; let last = last">
            <div class="row-design-timeline-step"
                [class.completed]="stage.completed"
                [class.negative]="stage.negative"
                [class.future]="stage.future"
                [title]="stage.isImplied ? '( skipped ) ' + stage.label : stage.label">
              <div class="row-design-step-dot">
                <ng-icon name="tablerCheck" *ngIf="stage.completed && !stage.negative"></ng-icon>
                <ng-icon name="tablerX" *ngIf="stage.negative"></ng-icon>
              </div>
              <span class="row-design-step-label">
                {{stage.label}}
              </span>
              <span class="row-design-step-date" *ngIf="stage.date">
                {{stage.date | timezoneDate:'dd MMM yyyy'}}
              </span>
            </div>
            <div class="row-design-timeline-connector"
                *ngIf="!last"
                [class.completed]="stage.completed && timelineDataGrouped[i + 1]?.completed">
            </div>
          </ng-container>
        </div>
      </div>
    </ng-template>

  </div>
</ng-container>

<!-- ============================================================ -->
<!-- CUSTOMER ROW DESIGN - For Customer Business Job List -->
<!-- Same as row-design but WITHOUT Rank and Match/Score columns -->
<!-- ============================================================ -->
<ng-container *ngIf="viewSize == 'customer-row-design'">
  <div class="cjrd-row" [ngClass]="{
    'cjrd-disabled': JobData?.status != 'ACTIVE' && !showCheckBox,
    'cjrd-featured': JobData?.isFeatured === true,
    'cjrd-selection-mode': showCheckBox}">

    <!-- Checkbox Column (for selection mode) -->
    <div class="cjrd-cell cjrd-checkbox-col" *ngIf="showCheckBox">
      <label class="checkbox-label font-normal">
        <input type="checkbox" (click)="selectCheckbox($event.target.checked, JobData)"
          [(ngModel)]="JobData.isSelected" name="list_name" />
        <span class="checkmark"></span>
      </label>
    </div>

    <!-- Owner Column -->
    <div class="cjrd-cell cjrd-owner-col">
      <div class="cjrd-owner-info">
        <div class="cjrd-owner-avatar" *ngIf="JobData?.user?.photo && JobData?.user?.photo != 'null' && JobData?.user?.photo != ''">
          <img [src]="JobData?.user?.photo?.startsWith('http') ? JobData?.user?.photo : url + JobData?.user?.photo" alt="owner" (error)="$event.target.style.display='none'">
        </div>
        <div class="cjrd-owner-avatar" *ngIf="!JobData?.user?.photo || JobData?.user?.photo == 'null' || JobData?.user?.photo == ''">
          <div class="cjrd-owner-initials"
            [style.background-color]="getColor(JobData?.user?.fullname)"
            [style.color]="getFullNameTextColor(JobData?.user?.fullname)">
            {{getInitials(JobData?.user?.fullname)}}
          </div>
        </div>
        <div class="cjrd-owner-details">
          <div class="cjrd-owner-name" title="{{JobData?.user?.fullname}}">{{JobData?.user?.fullname}}</div>
          <!-- Job owner's role (Recruiter / Bench Recruiter / Manager / …),
               under the owner name. Matches `.crd-owner-role` in the
               candidate card's customer-row-design so Job Center and Talent
               Center / Talent Pools describe their owner the same way. -->
          <div class="cjrd-owner-role" *ngIf="userTypeMap[JobData?.user?.userType]"
               [title]="userTypeMap[JobData?.user?.userType]">
            {{ userTypeMap[JobData?.user?.userType] }}
          </div>
        </div>
      </div>
    </div>

    <!-- Company Column -->
    <div class="cjrd-cell cjrd-company-col">
      <div class="cjrd-company-info">
        <div class="cjrd-company-details">
          <div class="cjrd-company-name" [title]="getCurrentOrganizationName(JobData)">{{getCurrentOrganizationName(JobData)}}</div>
          <div class="cjrd-company-location">{{JobData?.city}}<span *ngIf="JobData?.city && JobData?.state">, </span>{{JobData?.state}}</div>
          <div *ngIf="JobData?.latest && JobData.latest == true" class="cjrd-latest-badge">New</div>
        </div>
      </div>
    </div>

    <!-- Job Title & Location Column -->
    <div class="cjrd-cell cjrd-job-location-col">
      <div class="cjrd-job-location-info">
        <div class="cjrd-job-title-text" style="cursor: pointer;" (click)="openJobInSlidePanel(JobData)">{{JobData?.jobTitle}}</div>
        <div class="cjrd-job-id-text">Job ID: {{JobData?.jobId}}</div>
        <div class="cjrd-job-type-text" *ngIf="userTypeMap[JobData?.employmentType]">
          {{ userTypeMap[JobData?.employmentType] }}
        </div>
        <div class="cjrd-badge-row">
          <div class="cjrd-work-mode-badge" *ngIf="JobData?.workMode">{{JobData?.workMode}}</div>
          <div class="cjrd-status-badge" *ngIf="JobData?.status"
            [ngStyle]="getStyle(JobData?.status)">
            {{ convertSmallCase(JobData?.status) }}
          </div>
          <div class="urgent-hire-badge-compact" *ngIf="getActiveUrgencyDays(JobData)">
            <ng-icon name="tablerFlame" style="font-size: 9px;"></ng-icon> Urgent Hire - {{getActiveUrgencyDays(JobData)}}d
          </div>
        </div>
      </div>
    </div>

    <!-- Skills Column -->
    <div class="cjrd-cell cjrd-skills-col">
      <ng-container *ngIf="getAllSkills(JobData).length > 0; else noSkillsHyphen">
        <div class="cjrd-skills-container" *ngIf="!JobData.showAllSkills">
          <span class="cjrd-skill-tag cjrd-primary-skill"
            *ngFor="let skill of getAllSkills(JobData).slice(0, 2)"
            [ngStyle]="{ 'border-radius': getBorderRadius(skill) }"
            [title]="skill">
            {{skill}}
          </span>
          <span class="cjrd-skill-count"
            *ngIf="getAllSkills(JobData).length > 2" (click)="toggleSkills(JobData)">
            +{{ getAllSkills(JobData).length - 2 }}
          </span>
        </div>
        <div class="cjrd-skills-container cjrd-expanded" *ngIf="JobData.showAllSkills">
          <span class="cjrd-skill-tag cjrd-primary-skill"
            *ngFor="let skill of getAllSkills(JobData)"
            [ngStyle]="{ 'border-radius': getBorderRadius(skill) }"
            [title]="skill">
            {{skill}}
          </span>
          <span class="cjrd-skill-collapse" (click)="toggleSkills(JobData)">Show less</span>
        </div>
      </ng-container>
      <!-- No skills → show a hyphen instead of empty space. -->
      <ng-template #noSkillsHyphen>
        <span class="cjrd-empty-dash">-</span>
      </ng-template>
    </div>

    <!-- Rate Column -->
    <div class="cjrd-cell cjrd-rate-col">
      <!-- Has rate → normal top-aligned info block. -->
      <div class="cjrd-rate-info"
        *ngIf="JobData?.targetRateFrom!=undefined && JobData?.targetRateTo!=undefined">
        <div class="cjrd-rate-text"
          title="Employer Estimate: {{JobData?.targetRateFrom}} - {{JobData?.targetRateTo}}">
          <span>
            {{JobData?.country === 'US' ? '$' : ''}} {{JobData?.targetRateFrom}} - {{JobData?.targetRateTo}}
          </span>
          <ng-container *ngIf="JobData?.source !== 'CEIPAL'; else ceipalCurCjrd">
          <span *ngIf="JobData?.country == 'US'"> USD</span>
          <span *ngIf="JobData?.country == 'IN'"> INR</span>
          <span *ngIf="JobData?.country == 'CA'"> CAD</span>
          <span *ngIf="JobData?.country == 'AU'"> AUD</span>
          <span *ngIf="JobData?.country != 'AU' && JobData?.country != 'US' && JobData?.country != 'CA' && JobData?.country != 'IN'"> CUR</span>
          </ng-container>
          <ng-template #ceipalCurCjrd>
            <span title="{{JobData?.currency}}"> {{ getJobCurrency(JobData) }}</span>
          </ng-template>
        </div>
        <div class="cjrd-rate-period">
          <span *ngIf="JobData?.payType == 'Hourly'">Per Hour</span>
          <span *ngIf="JobData?.payType == 'Daily'">Per Day</span>
          <span *ngIf="JobData?.payType == 'Weekly'">Per Week</span>
          <span *ngIf="JobData?.payType == 'Monthly'">Per Month</span>
          <span *ngIf="JobData?.payType == 'Yearly'">Per Year</span>
        </div>
      </div>
      <!-- No rate → centered hyphen, vertically aligned to the row. -->
      <span class="cjrd-empty-dash"
        *ngIf="JobData?.targetRateFrom==undefined || JobData?.targetRateTo==undefined">-</span>
    </div>

    <!-- Engagement Column -->
    <div class="cjrd-cell cjrd-engagement-col">
      <div class="cjrd-engagement-stats">
        <div class="cjrd-stat-item">
          <div *ngIf="JobData.jobPostedBy!=userId && JobData.viewedByCount > 0"
            title="{{JobData.viewedByCount}} Views" style="cursor: context-menu;">
            <ng-icon name="tablerEye" class="icon-prime-color"></ng-icon>
            <span class="blue-color">{{ JobData.viewedByCount | compactCount }}</span> Views
          </div>
          <div *ngIf="JobData.jobPostedBy!=userId && JobData.viewedByCount == 0"
            title="0 Views" style="cursor: context-menu;">
            <ng-icon name="tablerEye" class="icon-prime-color"></ng-icon>
            <span class="blue-color">0</span> Views
          </div>
          <div (click)="goTo(JobData, 'views')"
            *ngIf="JobData.jobPostedBy==userId && JobData.viewedByCount > 0"
            title="{{JobData.viewedByCount}} Views" style="cursor: pointer;">
            <ng-icon name="tablerEye" class="icon-prime-color"></ng-icon>
            <span class="blue-color">{{ JobData.viewedByCount | compactCount }}</span> Views
          </div>
          <div *ngIf="JobData.jobPostedBy==userId && JobData.viewedByCount == 0"
            (click)="goTo(JobData, 'noviews')" title="0 Views">
            <ng-icon name="tablerEye" class="icon-prime-color"></ng-icon>
            <span class="blue-color">0</span> Views
          </div>
        </div>

        <div class="cjrd-stat-item" (click)="like(JobData)">
          <div title="Like" *ngIf="!JobData?.isLiked">
            <ng-icon name="tablerHeart" class="pointer icon-prime-color"></ng-icon>
          </div>
          <div title="Unlike" *ngIf="JobData?.isLiked">
            <ng-icon name="tablerHeart" class="liked pointer bg-heart"></ng-icon>
          </div>
          <div *ngIf="JobData.jobPostedBy==userId" (click)="goTo(JobData, 'jobs-liked')"
            title="{{JobData.likesCount}} Likes">
            <span class="blue-color" *ngIf="JobData.likesCount>0">{{ JobData.likesCount | compactCount }}</span>
            <span *ngIf="JobData.likesCount>0"> Like<span *ngIf="JobData.likesCount>1">s</span></span>
            <span class="blue-color" *ngIf="JobData.likesCount == 0">0</span>
            <span *ngIf="JobData.likesCount == 0"> Likes</span>
          </div>
          <div *ngIf="JobData.jobPostedBy!=userId" title="{{JobData.likesCount}} Likes" style="cursor: context-menu;">
            <span class="blue-color" *ngIf="JobData.likesCount>0">{{ JobData.likesCount | compactCount }}</span>
            <span *ngIf="JobData.likesCount>0"> Like<span *ngIf="JobData.likesCount>1">s</span></span>
            <span class="blue-color" *ngIf="JobData.likesCount == 0">0</span>
            <span *ngIf="JobData.likesCount == 0"> Likes</span>
          </div>
        </div>
      </div>
    </div>

    <!-- Quick Actions Column -->
    <div class="cjrd-cell cjrd-actions-col">
      <div class="cjrd-action-buttons">
        <button class="cjrd-action-btn" title="View Job" (click)="openJobInSlidePanel(JobData)">
          <ng-icon name="tablerEye"></ng-icon>
        </button>

        <button class="cjrd-action-btn" title="Apply Job"
          [ngClass]="{'disabled': JobData.status!='ACTIVE'}"
          *ngIf="JobData.jobPostedBy!=userId && (userType == 'BENCH_RECRUITER'
          || userType == 'student' || userType == 'JOB_SEEKER'
          || userType == 'FREELANCE_RECRUITER' || userType == 'MANAGEMENT_TALENT_ACQUISITION')"
          (click)="apply(JobData, connectionTemplate, candidateSupplyTemplate)">
          <ng-icon name="tablerHandClick"></ng-icon>
        </button>

       <button class="cjrd-action-btn" title="{{JobData.nonSeenMessageCount > 0 ? JobData.nonSeenMessageCount + ' Messages' : 'No Messages'}}"
          *ngIf="JobData.chatHistoryCount > 0"
          (click)="openMessagecheckInteraction(JobData, connectionTemplate)">
           <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path></svg>
          <span class="chat-icon-wrapper">
          <span class="noti-badge noti-chat-ico" *ngIf="JobData.nonSeenMessageCount>0">{{JobData.nonSeenMessageCount}}</span>
          </span>
        </button>

        <button class="cjrd-action-btn" title="No Messages"
          *ngIf="JobData.jobPostedBy!=userId && JobData.chatHistoryCount == 0"
          (click)="openMessagecheckInteraction(JobData, connectionTemplate)">
          <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path></svg>
        </button>

        <button class="cjrd-action-btn" title="No Messages"
          *ngIf="JobData.jobPostedBy==userId && JobData.chatHistoryCount == 0">
          <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path></svg>
        </button>

        <button class="cjrd-action-btn" title="More Options" dropdown>
          <ng-icon name="tablerDots" dropdownToggle></ng-icon>
          <ul *dropdownMenu class="dropdown-menu">
            <li><a (click)="saveJob()">Save Job</a></li>
            <li *ngIf="reportEnabled"><a (click)="reportJob()">Report Job</a></li>
          </ul>
        </button>
      </div>
    </div>

  </div>
</ng-container>

<!-- ═══════════════════════════════════════════════════════════════
     V3 ROW DESIGN — mirrors candidate-card-table-view [designVersion='v3']
     ═══════════════════════════════════════════════════════════════ -->
<ng-container *ngIf="viewSize == 'jc-v3-row'">
  <div class="jc-v3-cand-card" [ngClass]="{
        'disabled': JobData?.status != 'ACTIVE' || !JobData?.availability || (candidateData && (!candidateData.availability || candidateData.status !== 'ACTIVE')),
        'featured-background': JobData?.isFeatured === true}">
    <div class="jc-v3-cand-top">

      <!-- Rank -->
      <div class="jc-v3-c-rank">{{ indexInput + 1 }}</div>

      <!-- Col1: Job Owner — the recruiter / manager who posted this job
           (`jobOwner` = JobDataUser, the `item.user` every candidate-page
           tab passes; falls back to JobData.user). Shown on Job Invites,
           Applied, and Marketplace Jobs (all render this jc-v3-row card).
           Resume Requests has its own owner column in
           candidate-requests-received. Hidden when owner data is absent so
           we never render an empty avatar. -->
      <div class="jc-v3-c-col1" *ngIf="jobOwner?.fullname || jobOwner?.firstName">
        <div class="jc-v3-c-rec-row">
          <img *ngIf="jobOwner?.photo" class="jc-v3-c-rec-av"
               [src]="getPhotoUrl(jobOwner.photo)" alt="owner"
               (error)="$event.target.style.display='none'">
          <div *ngIf="!jobOwner?.photo" class="jc-v3-c-rec-av"
               [style.background-color]="getColor(jobOwner?.fullname || (jobOwner?.firstName + ' ' + jobOwner?.lastName))"
               [style.color]="getFullNameTextColor(jobOwner?.fullname || (jobOwner?.firstName + ' ' + jobOwner?.lastName))">
            {{ getInitials(jobOwner?.fullname || (jobOwner?.firstName + ' ' + jobOwner?.lastName)) }}
          </div>
          <div class="jc-v3-c-rec-info" style="flex:1;min-width:0;overflow:hidden;">
            <div class="jc-v3-c-rec-name"
                 [title]="jobOwner?.fullname || (jobOwner?.firstName + ' ' + jobOwner?.lastName)">
              {{ jobOwner?.fullname || (jobOwner?.firstName + ' ' + jobOwner?.lastName) }}
            </div>
            <div class="jc-v3-c-rec-role" *ngIf="jobOwner?.userType"
                 [title]="formatUserType(jobOwner?.userType)">
              {{ formatUserType(jobOwner?.userType) }}
            </div>
          </div>
        </div>
      </div>

      <!-- Col2: Job info -->
      <div class="jc-v3-c-col2">
        <div class="jc-v3-c-name-row">
          <span class="jc-v3-c-name jc-v3-c-name-link" (click)="openJobInSlidePanel(JobData)" style="cursor:pointer;" [title]="JobData?.jobTitle">{{ JobData?.jobTitle }}</span>
          <span class="jc-v3-c-cid jc-v3-c-cid-link" *ngIf="JobData?.jobReferenceId" (click)="openJobInSlidePanel(JobData)" [title]="JobData?.jobReferenceId">{{ JobData?.jobReferenceId }}</span>
          <span class="jc-v3-c-cand-status" *ngIf="getJobStatusLabel(JobData?.status)"
                [style.background-color]="getStageStyle(JobData?.status)?.background"
                [style.color]="getStageStyle(JobData?.status)?.color">
            {{ getJobStatusLabel(JobData?.status) }}
          </span>
          <!-- Urgent-hire badge intentionally omitted on the jc-v3-row card:
               Job Invites, Applied, and Marketplace Jobs tabs don't surface the
               urgency indicator. -->
        </div>
        <div class="jc-v3-c-title" *ngIf="JobData?.jobClassification">{{ JobData?.jobClassification }}</div>
        <!-- AUDIT_04 Batch 4 — surface employmentType (Full-time / Contract /
             Contract-to-Hire) that V2 rendered via `userTypeMap` but V3
             dropped. Displayed next to jobClassification when both exist. -->
        <div class="jc-v3-c-emp-type" *ngIf="JobData?.employmentType">
          {{ JobData?.employmentType | titlecase }}
        </div>
        <div class="jc-v3-c-exp" *ngIf="JobData?.experienceFrom || JobData?.experienceTo">
          {{ JobData?.experienceFrom }}–{{ JobData?.experienceTo }} yrs exp
        </div>
        <div class="jc-v3-c-meta">
          <div class="jc-v3-c-mi" *ngIf="JobData?.city || JobData?.state">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/></svg>
            {{ JobData?.city }}<ng-container *ngIf="JobData?.state">, {{ JobData?.state }}</ng-container>
          </div>
        </div>
        <!-- AUDIT_04 Batch 4 — salary now shows currency symbol + country
             suffix + per-payType unit (parity with V2 `:1665-1684`). -->
        <div class="jc-v3-c-foot">
          <span class="jc-v3-c-pill jc-v3-c-pill-p" *ngIf="JobData?.workMode">{{ JobData?.workMode }}</span>
          <span class="jc-v3-c-rate" *ngIf="JobData?.targetRateFrom && JobData?.targetRateTo; else noRateV3Row">
            <span *ngIf="JobData?.country === 'US'">$</span>{{ JobData?.targetRateFrom }}–{{ JobData?.targetRateTo }}
            <ng-container *ngIf="JobData?.source !== 'CEIPAL'; else ceipalCurV3Row">
            <span *ngIf="JobData?.country === 'US'"> USD / </span>
            <span *ngIf="JobData?.country === 'IN'"> INR / </span>
            <span *ngIf="JobData?.country === 'CA'"> CAD / </span>
            <span *ngIf="JobData?.country === 'AU'"> AUD / </span>
            <span *ngIf="JobData?.country && JobData?.country !== 'US' && JobData?.country !== 'IN' && JobData?.country !== 'CA' && JobData?.country !== 'AU'"> CUR / </span>
            </ng-container>
            <ng-template #ceipalCurV3Row>
              <span title="{{JobData?.currency}}"> {{ getJobCurrency(JobData) }} / </span>
            </ng-template>
            <span *ngIf="JobData?.payType === 'Hourly'">Hr</span>
            <span *ngIf="JobData?.payType === 'Daily'">Day</span>
            <span *ngIf="JobData?.payType === 'Weekly'">Week</span>
            <span *ngIf="JobData?.payType === 'Monthly'">Month</span>
            <span *ngIf="JobData?.payType === 'Yearly'">Year</span>
          </span>
          <!-- No employer rate on the job — show an explicit "not available"
               instead of a half-rendered "$– USD /" chip. -->
          <ng-template #noRateV3Row>
            <span class="jc-v3-c-rate">$ Not available</span>
          </ng-template>
        </div>
      </div>

      <!-- Col3: Skills — primary first, then secondary; collapsed to 5 until
           the user clicks "+N more". Primary and secondary share one chip
           style (wireframe parity: all purple, no gray differentiation —
           matches the candidate card). Uses the existing `getAllSkills`
           helper + `toggleSkills(JobData)` already wired in job-card.ts. -->
      <div class="jc-v3-c-col3">
        <div class="jc-v3-c-skills">
          <span class="jc-v3-skill-tag"
                *ngFor="let skill of (JobData.showAllSkills ? getAllSkills(JobData) : getAllSkills(JobData).slice(0, 5))">
            {{ skill }}
          </span>
          <span class="jc-v3-skill-more"
                *ngIf="getAllSkills(JobData).length > 5"
                (click)="toggleSkills(JobData); $event.stopPropagation()">
            <ng-container *ngIf="!JobData.showAllSkills">+{{ getAllSkills(JobData).length - 5 }} more</ng-container>
            <ng-container *ngIf="JobData.showAllSkills">Show less</ng-container>
          </span>
        </div>
      </div>

      <!-- Col4: Engagement + Actions -->
      <div class="jc-v3-c-col4">
        <!-- Match % badge — mirrors V2 row-design (line 1557) which always
             renders the match cell, falling back to "-" when no score.
             `getJobMatchScore()` normalizes matchingScore / matchScore /
             score. Click only wires when a real score exists; no-score badge
             is non-interactive. -->
        <div class="jc-v3-c-match-badge"
             [class.amber]="jobMatchTier() === 'amber'"
             [class.red]="jobMatchTier() === 'red'"
             [class.no-score]="getJobMatchScore() == null"
             [style.cursor]="getJobMatchScore() != null ? 'pointer' : 'default'"
             (click)="getJobMatchScore() != null ? openMatch(JobData, $event) : null"
             [title]="getJobMatchScore() != null ? 'View AI match insights' : ''">
          <div class="jc-v3-c-match-pct"
               [class.amber]="jobMatchTier() === 'amber'"
               [class.red]="jobMatchTier() === 'red'">
            <ng-container *ngIf="getJobMatchScore() != null; else noMatchPct">
              {{ getJobMatchScore() % 1 === 0 ? getJobMatchScore() + '%' : (getJobMatchScore() | number:'1.2-2') + '%' }}
            </ng-container>
            <ng-template #noMatchPct>-</ng-template>
          </div>
          <div class="jc-v3-c-match-lbl"
               [class.amber]="jobMatchTier() === 'amber'"
               [class.red]="jobMatchTier() === 'red'">
            Match
            <svg class="jc-v3-c-match-arrow"
                 *ngIf="getJobMatchScore() != null"
                 width="7" height="7" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
              <line x1="7" y1="17" x2="17" y2="7"/>
              <polyline points="7 7 17 7 17 17"/>
            </svg>
          </div>
        </div>

        <!-- Apply — Marketplace Jobs only. Hidden on the Jobs Applied tab: the
             candidate has already applied there, so the button is redundant. -->
        <button class="jc-v3-btn jc-v3-btn-primary jc-v3-btn-sm jc-v3-c-apply-btn"
          *ngIf="pageFrom === 'suggestedJobs' && JobData?.jobPostedBy != userId && (userType == 'BENCH_RECRUITER' || userType == 'student' || userType == 'JOB_SEEKER' || userType == 'FREELANCE_RECRUITER' || userType == 'MANAGEMENT_TALENT_ACQUISITION')"
          [class.disabled]="JobData?.status != 'ACTIVE' || (pageFrom === 'suggestedJobs' && !JobData?.availability)"
          (click)="apply(JobData, connectionTemplate, candidateSupplyTemplate)">
          Apply
        </button>

        <div class="jc-v3-c-act-row">

          <!-- Views: owner-clickable, non-owner display-only -->
          <div class="jc-v3-c-eng-item" *ngIf="JobData.jobPostedBy == userId && JobData.viewedByCount > 0"
            (click)="goTo(JobData, 'views')" title="{{JobData.viewedByCount}} Views" style="cursor:pointer;">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>
            {{ JobData.viewedByCount | compactCount }}
          </div>
          <div class="jc-v3-c-eng-item" *ngIf="JobData.jobPostedBy == userId && JobData.viewedByCount == 0"
            (click)="goTo(JobData, 'noviews')" title="0 Views" style="cursor:pointer;">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>
            0
          </div>
          <div class="jc-v3-c-eng-item" *ngIf="JobData.jobPostedBy != userId"
            title="{{JobData.viewedByCount || 0}} Views" style="cursor:context-menu;">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>
            {{ JobData.viewedByCount | compactCount }}
          </div>

          <!-- Like: heart icon + count merged into a single box (wireframe
               parity). Outer click toggles like; the count span (owner only)
               stops propagation and navigates to the Likes list instead. -->
          <div class="jc-v3-c-eng-item jc-v3-c-eng-like"
            *ngIf="JobData?.isLiked != null"
            [class.jc-v3-c-liked]="JobData?.isLiked"
            style="cursor:pointer;"
            (click)="like(JobData)"
            title="{{JobData.likesCount || 0}} Likes">
            <svg viewBox="0 0 24 24"
              [attr.fill]="JobData?.isLiked ? '#F43F5E' : 'none'"
              [attr.stroke]="JobData?.isLiked ? '#F43F5E' : 'currentColor'" stroke-width="2">
              <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/>
            </svg>
            <span *ngIf="JobData.jobPostedBy == userId"
              (click)="$event.stopPropagation(); goTo(JobData, 'jobs-liked')">
              {{ JobData.likesCount | compactCount }}
            </span>
            <span *ngIf="JobData.jobPostedBy != userId">
              {{ JobData.likesCount | compactCount }}
            </span>
          </div>

          <div class="jc-v3-c-vsep"></div>

          <!-- Status dropdown — Job Invite flow (showStatus=true).
               Hidden on Marketplace Jobs (pageFrom=suggestedJobs) where status
               editing from the card isn't applicable. -->
          <div class="jc-v3-c-stage" dropdown id="jb_dpDown_v3_1" *ngIf="showStatus && pageFrom != 'suggestedJobs'"
            [ngClass]="{disabled : !candidateData?.availability || candidateData?.status != 'ACTIVE' }">
            <button dropdownToggle class="jc-v3-c-stage-btn" aria-expanded="true"
              (click)="triggerChange(JobData?.jobReferenceId)"
              [style.background-color]="getStageStyle(JobData?.currentStatus || 'APPLIED')?.background"
              [style.color]="getStageStyle(JobData?.currentStatus || 'APPLIED')?.color"
              [style.border]="'1px solid ' + (getStageStyle(JobData?.currentStatus || 'APPLIED')?.background || '#E5E7EB')">
              {{ getStageLabel(JobData?.currentStatus || 'APPLIED') }}
              <ng-icon name="tablerChevronDown" *ngIf="!isExcludedStatus(JobData?.currentStatus , 'JOB_INVITE')"></ng-icon>
            </button>
            <ng-container *ngIf="!isExcludedStatus(JobData?.currentStatus , 'JOB_INVITE')">
              <ul *dropdownMenu class="dropdown-menu dropdown-menu-right jc-v3-dh-more-dropdown" role="menu">
                <li role="menuitem" *ngFor="let statusData of filterApplicant(JobData?.currentStatus , 'JOB_INVITE')"
                  id="{{statusData?.item}}" (click)="updatestatusPayrate(statusData?.itemId ,JobData,payrateTemplate)">
                  <a class="dropdown-item">{{statusData?.item | titlecase}}</a>
                </li>
              </ul>
            </ng-container>
          </div>

          <!-- Status dropdown — Jobs Applied flow (!showStatus && !jobstatus).
               Hidden on Marketplace Jobs (pageFrom=suggestedJobs). -->
          <div class="jc-v3-c-stage" dropdown id="jb_dpDown_v3_2"
            [ngClass]="{disabled : !candidateData?.availability || candidateData?.status != 'ACTIVE' }"
            *ngIf="JobData?.status != 'DRAFTED' && !showStatus && !jobstatus && pageFrom != 'suggestedJobs'">
            <button dropdownToggle class="jc-v3-c-stage-btn" aria-expanded="true"
              [style.background-color]="getStageStyle(JobData?.currentStatus || 'APPLIED')?.background"
              [style.color]="getStageStyle(JobData?.currentStatus || 'APPLIED')?.color"
              [style.border]="'1px solid ' + (getStageStyle(JobData?.currentStatus || 'APPLIED')?.background || '#E5E7EB')">
              {{ getStageLabel(JobData?.currentStatus || 'APPLIED') }}
              <ng-icon name="tablerChevronDown" *ngIf="!isExcludedStatus(JobData?.currentStatus)"></ng-icon>
            </button>
            <ng-container *ngIf="!isExcludedStatus(JobData?.currentStatus)">
              <ul *dropdownMenu class="dropdown-menu dropdown-menu-right jc-v3-dh-more-dropdown" role="menu">
                <li role="menuitem" *ngFor="let statusData of filterApplicant(JobData?.currentStatus)"
                  id="{{statusData?.item}}" (click)="validateNegativeStatus(statusData , JobData)">
                  <a class="dropdown-item">{{statusData?.item}}</a>
                </li>
              </ul>
            </ng-container>
          </div>

          <button *ngIf="jobstatus" type="button" class="jc-v3-btn jc-v3-btn-primary jc-v3-btn-sm">Active</button>

          <!-- View job -->
          <div class="jc-v3-c-ibt" (click)="openJobInSlidePanel(JobData)" title="View Job">
            <ng-icon name="tablerEye"></ng-icon>
          </div>

          <!-- Chat / Messages.
               AUDIT_04 Batch 4 — owner-side no-messages variant added
               (V2 `:1801-1806`) so job posters can initiate a chat from
               the card even when no thread exists. Previously the chat
               icon only rendered for non-owners in the zero-messages
               state, leaving owners with no way to start a conversation. -->
          <div class="jc-v3-c-ibt jc-v3-c-ibt-chat" *ngIf="JobData.chatHistoryCount > 0"title="{{JobData.nonSeenMessageCount > 0 ? JobData.nonSeenMessageCount + ' Messages' : 'No Messages'}}"
            (click)="openMessagecheckInteraction(JobData, connectionTemplate)">
            <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path></svg>
            <span class="jc-v3-c-msg-count" *ngIf="JobData.nonSeenMessageCount > 0">{{ JobData.nonSeenMessageCount }}</span>
          </div>
          <div class="jc-v3-c-ibt" *ngIf="JobData.jobPostedBy != userId && JobData.chatHistoryCount == 0"
            title="No Messages" (click)="openMessagecheckInteraction(JobData, connectionTemplate)">
            <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path></svg>
          </div>
          <div class="jc-v3-c-ibt" *ngIf="JobData.jobPostedBy == userId && JobData.chatHistoryCount == 0"
            title="No Messages" (click)="openMessagecheckInteraction(JobData, connectionTemplate)">
            <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path></svg>
          </div>

          <!-- Documents -->
          <div class="jc-v3-c-ibt"
            *ngIf="['OFFER-ACCEPTED','PRE-ONBOARDED','ONBOARDED'].includes(JobData?.currentStatus) && pageFrom != 'suggestedJobs'"
            title="Candidate Document" (click)="openDocuments()">
            <ng-icon name="tablerFileText"></ng-icon>
            <span class="jc-v3-c-doc-badge" *ngIf="JobData.totalMandatoryDocuments > 0">{{ JobData.totalMandatoryDocuments }}</span>
          </div>
        </div>
      </div>

    </div>

    <!-- Stage Timeline — wireframe-style continuous purple progress line
         with dots overlaid. Mirrors candidate-card-table-view's V3 timeline.
         Driven by `timelineDataGrouped` populated by `prepareTimeline()`.
         Negative stage keeps its red dot/label/date via `.negative` while
         the line stays purple (treated as the "current" position). -->
    <ng-container *ngIf="showTimeline && JobData?.currentStatus">
      <div class="jc-v3-tl-progress" *ngIf="timelineDataGrouped && timelineDataGrouped.length > 0">
        <div class="jc-v3-tl-track">
          <!-- Continuous gray line behind all dots -->
          <div class="jc-v3-tl-line"></div>
          <!-- Purple progress overlay — extends to the latest completed dot -->
          <div class="jc-v3-tl-line-progress"
               [style.width.%]="getProgressLinePct(timelineDataGrouped)"></div>
          <div class="jc-v3-tl-step"
              *ngFor="let stage of timelineDataGrouped; let i = index"
              [class.completed]="stage.completed"
              [class.current]="stage.completed && !stage.negative && !timelineDataGrouped[i + 1]?.completed"
              [class.negative]="stage.negative"
              [class.future]="stage.future"
              [title]="stage.isImplied ? '( skipped ) ' + stage.label : stage.label">
            <div class="jc-v3-tl-step-dot"></div>
            <span class="jc-v3-tl-step-label">
              {{stage.label}}
            </span>
            <span class="jc-v3-tl-step-date" *ngIf="stage.date">
              {{stage.date | timezoneDate:'dd MMM yyyy'}}
            </span>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</ng-container>

<ng-template #DetailsPopup let-modal>
  <div class="match-details-modal">
    <!-- Enhanced Header with Score Badge -->
    <div class="modal-header-enhanced">
      <div class="header-content">
        <div class="score-badge-container">
          <div class="score-badge">
            <span class="score-value">{{candidateScore}}</span>
            <span class="score-label">Match Score</span>
          </div>
        </div>
        <div class="header-text">
          <h3 class="modal-title">Candidate Match Analysis</h3>
          <p class="modal-subtitle">Detailed breakdown of compatibility factors</p>
        </div>
      </div>
      <button type="button" class="close-btn-modern" aria-label="Close" (click)="closeModal()">
        <ng-icon name="tablerX"></ng-icon>
      </button>
    </div>

    <!-- Modal Body with Enhanced Sections -->
    <div class="modal-body-enhanced">
      <div *ngFor="let r of reasons; let i = index" class="reason-card">

        <!-- Overall Reason Section -->
        <div class="reason-summary-section">
          <div class="section-icon reason-icon">
            <ng-icon name="tablerInfoCircle"></ng-icon>
          </div>
          <div class="section-content">
            <h4 class="section-title">Match Summary</h4>
            <p class="reason-summary-text">{{ r.reason }}</p>
          </div>
        </div>

        <!-- Strengths Section with Green Theme -->
        <div class="strengths-section">
          <div class="section-header">
            <div class="section-icon strengths-icon">
              <!-- <ng-icon name="tablerCircleCheck"></ng-icon> -->
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                  <path fill-rule="evenodd"
                    d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                    clip-rule="evenodd" />
                    </svg>
            </div>
            <h4 class="section-title strengths-title">
              Strengths
              <span class="count-badge strengths-badge">{{ r.strengths?.length || 0 }}</span>
            </h4>
          </div>
          <div class="section-body">
            <div class="strength-item" *ngFor="let s of r.strengths; let idx = index">
              <div class="item-bullet strengths-bullet">
                <!-- <ng-icon name="tablerCheck"></ng-icon> -->
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                  <path fill-rule="evenodd"
                    d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                    clip-rule="evenodd" />
                </svg>
              </div>
              <span class="item-text">{{ s }}</span>
            </div>
            <div *ngIf="!r.strengths || r.strengths.length === 0" class="empty-state">
              <ng-icon name="tablerInfoCircle"></ng-icon>
              <span>No specific strengths identified</span>
            </div>
          </div>
        </div>

        <!-- Weaknesses Section with Red Theme -->
        <div class="weaknesses-section">
          <div class="section-header">
            <div class="section-icon weaknesses-icon">
              <!-- <ng-icon name="tablerAlertTriangle"></ng-icon> -->
              <ng-icon name="tablerAlertTriangle"></ng-icon>
            </div>
            <h4 class="section-title weaknesses-title">
              Areas for Improvement
              <span class="count-badge weaknesses-badge">{{ r.weaknesses?.length || 0 }}</span>
            </h4>
          </div>
          <div class="section-body">
            <div class="weakness-item" *ngFor="let w of r.weaknesses; let idx = index">
              <div class="item-bullet weaknesses-bullet">
                <!-- <ng-icon name="tablerCircleMinus"></ng-icon> -->
                <ng-icon name="tablerAlertCircle"></ng-icon>
              </div>
              <span class="item-text">{{ w }}</span>
            </div>
            <div *ngIf="!r.weaknesses || r.weaknesses.length === 0" class="empty-state">
              <ng-icon name="tablerThumbUp"></ng-icon>
              <span>No significant gaps identified</span>
            </div>
          </div>
        </div>

        
      </div>

      <!-- Empty State if No Reasons -->
      <div *ngIf="!reasons || reasons.length === 0" class="no-data-state">
        <ng-icon name="tablerSearch"></ng-icon>
        <p>No match analysis available for this candidate.</p>
      </div>
    </div>

      <!-- Enhanced Footer -->
      <div class="modal-footer-enhanced">
        <button class="btn-close-modern" (click)="closeModal()">
          Close
        </button>
      </div>
    </div>
  </ng-template>

<app-match-percentage-details
  *ngIf="showPercentageDetails"
  [isOpen]="showPercentageDetails"
  [jobId]="JobData.jobId"
  [candidateId]="candidateData?.candidateId"
  [pageFrom]="pageFrom"
  (close)="closePercentageDetails()">
</app-match-percentage-details>